(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5275],{

/***/ 18510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/priority/[slug]",
      function () {
        return __webpack_require__(22553);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(76131);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/@casavo/habitat/dist/index.js + 8 modules
var dist = __webpack_require__(77068);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(3607);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/auth/UserAuthentication/index.ts + 27 modules
var UserAuthentication = __webpack_require__(21682);
// EXTERNAL MODULE: ./src/components/ConceptImage.tsx
var ConceptImage = __webpack_require__(24454);
// EXTERNAL MODULE: ./src/components/Gallery/Buttons/DetailGalleryButton.tsx
var DetailGalleryButton = __webpack_require__(52202);
// EXTERNAL MODULE: ./src/components/Gallery/Buttons/Icon.tsx
var Icon = __webpack_require__(57322);
// EXTERNAL MODULE: ./src/components/Gallery/DesktopImageGallery/index.tsx + 1 modules
var DesktopImageGallery = __webpack_require__(82179);
// EXTERNAL MODULE: ./src/components/Gallery/MobileImageGallery/index.tsx + 1 modules
var MobileImageGallery = __webpack_require__(84604);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var components_Icon = __webpack_require__(81016);
// EXTERNAL MODULE: ./src/components/Layout/index.ts + 9 modules
var Layout = __webpack_require__(97275);
// EXTERNAL MODULE: ./src/components/Layout/index.css.tsx
var index_css = __webpack_require__(44290);
// EXTERNAL MODULE: ./src/components/Modal/Types/GalleryAndPlanimetry/index.tsx + 7 modules
var GalleryAndPlanimetry = __webpack_require__(51354);
// EXTERNAL MODULE: ./src/components/Modal/Types/LoginModalForm/index.tsx + 1 modules
var LoginModalForm = __webpack_require__(34916);
// EXTERNAL MODULE: ./src/components/Translated.tsx
var Translated = __webpack_require__(36510);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(41354);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(21565);
// EXTERNAL MODULE: ./src/components/Disclaimer/index.tsx
var Disclaimer = __webpack_require__(6544);
// EXTERNAL MODULE: ./src/components/FormFields/FormikInput/index.tsx + 3 modules
var FormikInput = __webpack_require__(77995);
// EXTERNAL MODULE: ./src/components/Modal/ModalBase/index.tsx + 1 modules
var ModalBase = __webpack_require__(59850);
// EXTERNAL MODULE: ./src/components/PriorityCardBadge/index.tsx + 1 modules
var PriorityCardBadge = __webpack_require__(27638);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/utils/deferredRequest.ts
var deferredRequest = __webpack_require__(21702);
// EXTERNAL MODULE: ./src/utils/phoneNumberValidator.ts
var phoneNumberValidator = __webpack_require__(13917);
// EXTERNAL MODULE: ./src/utils/prefix.ts
var prefix = __webpack_require__(41073);
// EXTERNAL MODULE: ./src/utils/tracking/eventCategory.ts
var eventCategory = __webpack_require__(66576);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: src/containers/PriorityDetail/sections/RequestVisit/VisitRequestForm/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/PriorityDetail/sections/RequestVisit/VisitRequestForm/styles.css.ts.vanilla.css","source":"Ll8xdGVnc2NyMCB7CiAgbWF4LXdpZHRoOiA0OTBweDsKfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(70667);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/RequestVisit/VisitRequestForm/styles.css.ts

var visitRequestModalStyle = '_1tegscr0';
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/RequestVisit/VisitRequestForm/VisitRequestModal.tsx






















var getValidationSchema = function(t, hasPhone) {
    return es/* object */.Ry().shape({
        name: es/* string */.Z_().required(t("common:required-field-message")),
        phone: (0,phoneNumberValidator/* getPhoneNumberValidator */.i)(t("common:required-field-message"), t("common:invalid-phone-message"), hasPhone),
        phonePrefix: es/* string */.Z_().required()
    });
};
var getInitialValues = function(lang, name, phone) {
    return {
        name: name,
        phone: phone || "",
        phonePrefix: (0,prefix/* getPrefixFromCountryCode */.a)((0,prefix/* langToCountryCode */.J)(lang))
    };
};
var VisitRequestModal = function(param) {
    var buyerInfo = param.buyerInfo, expressVisitInterest = param.expressVisitInterest, setShowToastError = param.setShowToastError, thankyouPageUrl = param.thankYouPageUrl;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var router = (0,next_router.useRouter)();
    var validationSchema = (0,react.useMemo)(function() {
        return getValidationSchema(t, Boolean(buyerInfo === null || buyerInfo === void 0 ? void 0 : buyerInfo.phone));
    }, []);
    var submitLabel = t("priority:Priority_DetailPage_FloatingBanner_CTA");
    var ref1 = (0,AuthProvider/* useAuthentication */.JL)(), isLoading = ref1.isLoading, user = ref1.user;
    var name = (user === null || user === void 0 ? void 0 : user.first_name) && (user === null || user === void 0 ? void 0 : user.last_name) && !isLoading ? "".concat(user === null || user === void 0 ? void 0 : user.first_name, " ").concat(user === null || user === void 0 ? void 0 : user.last_name) : "";
    var initialValues = (0,react.useMemo)(function() {
        return getInitialValues(lang, name, buyerInfo === null || buyerInfo === void 0 ? void 0 : buyerInfo.phone);
    }, [
        name
    ]);
    var ref2 = (0,react.useState)(false), isSubmitting = ref2[0], setIsSubmitting = ref2[1];
    var showFormikInputWithPhonePrefix = !(buyerInfo === null || buyerInfo === void 0 ? void 0 : buyerInfo.phone);
    var sendVisitInterest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(_param) {
            var phonePrefix, values, phone, isLogged;
            return (0,tslib_es6.__generator)(this, function(_state) {
                phonePrefix = _param.phonePrefix, values = (0,_object_without_properties/* default */.Z)(_param, [
                    "phonePrefix"
                ]);
                phone = showFormikInputWithPhonePrefix ? "".concat(phonePrefix).concat(values.phone) : values.phone;
                isLogged = (buyerInfo === null || buyerInfo === void 0 ? void 0 : buyerInfo.email) === undefined;
                if (isLogged) {
                    return [
                        2,
                        expressVisitInterest({
                            buyerPhoneNumber: phone,
                            isLogged: isLogged,
                            name: values.name
                        })
                    ];
                } else {
                    return [
                        2,
                        expressVisitInterest({
                            buyerPhoneNumber: phone,
                            crmContactId: buyerInfo.crm_contact_id,
                            email: buyerInfo.email,
                            isLogged: false,
                            name: values.name,
                            score: buyerInfo.score
                        })
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function sendVisitInterest(_param) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityVisitModalForm */.z.PriorityVisitModalForm, "SubmitScheduleVisit");
                        setIsSubmitting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,deferredRequest/* deferredRequest */.e)(sendVisitInterest(values), 1000)
                        ];
                    case 2:
                        _state.sent();
                        (0,eventsHandlers/* handleShow */.Hf)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "RequestVisit_Success");
                        router.push(thankyouPageUrl);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setShowToastError(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSubmitting(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* ModalBase */.e, {
        noPadding: true,
        className: visitRequestModalStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        paddingX: "2xl",
                        paddingY: "3xl"
                    }),
                    children: t("priority:Priority_PhoneNumberModal_Title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityCardBadge/* PriorityBadge */.U, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    initialValues: initialValues,
                    validateOnMount: true,
                    validationSchema: validationSchema,
                    onSubmit: handleSubmit,
                    children: function(param) {
                        var isValid = param.isValid;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        paddingX: "2xl"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                marginBottom: "s"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                                required: true,
                                                label: t("contact-form:name"),
                                                name: "name",
                                                type: "text"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,sprinkles_css/* sprinkles */.K)({
                                                marginBottom: "3xl"
                                            }),
                                            children: showFormikInputWithPhonePrefix ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                                required: true,
                                                inputMode: "tel",
                                                label: t("contact-form:phone"),
                                                name: "phone",
                                                prefixName: "phonePrefix",
                                                type: "tel"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikInput/* default */.Z, {
                                                required: true,
                                                inputMode: "tel",
                                                label: t("contact-form:phone"),
                                                name: "phone",
                                                type: "tel"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Disclaimer/* default */.Z, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        marginBottom: "l",
                                        paddingX: "3xl"
                                    }),
                                    cta: submitLabel
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        marginBottom: "xl"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                        center: true,
                                        disabled: !isValid,
                                        label: submitLabel,
                                        loading: isSubmitting,
                                        minWidth: 220,
                                        type: "submit"
                                    })
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/RequestVisit/VisitRequestForm/index.ts


// EXTERNAL MODULE: ./src/lib/api-gluglu-auth.ts
var api_gluglu_auth = __webpack_require__(636);
// EXTERNAL MODULE: ./src/lib/api-gluglu-open.ts
var api_gluglu_open = __webpack_require__(18872);
// EXTERNAL MODULE: ./src/lib/tenants/constants.ts
var constants = __webpack_require__(21530);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/useExpressPotentialPropertyVisitInterest.tsx





function useExpressPotentialPropertyVisitInterest(transactionId) {
    return function(params) {
        switch(params.tenant){
            case constants/* TENANTS.casavo */.rk.casavo:
                return sendCasavoVisitInterest(transactionId, params.args);
            case constants/* TENANTS.ucsc */.rk.ucsc:
                return sendUCSCVisitInterest(transactionId, params.args);
        }
    };
}
function sendCasavoVisitInterest(transactionId, args) {
    return _sendCasavoVisitInterest.apply(this, arguments);
}
function _sendCasavoVisitInterest() {
    _sendCasavoVisitInterest = (0,_async_to_generator/* default */.Z)(function(transactionId, args) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(args.isLogged === false)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api_gluglu_open/* initApi */.g8)().potentialPropertyVisitInterest(transactionId, {
                            crm_contact_id: args.crmContactId,
                            email: args.email,
                            name: args.name,
                            phone: args.buyerPhoneNumber,
                            score: args.score,
                            tenant_id: constants/* TENANTS.casavo */.rk.casavo
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (0,api_gluglu_auth/* initApi */.g8)().potentialPropertyVisitInterest(transactionId, {
                            name: args.name,
                            phone: args.buyerPhoneNumber
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendCasavoVisitInterest.apply(this, arguments);
}
function sendUCSCVisitInterest(transactionId, _) {
    return _sendUCSCVisitInterest.apply(this, arguments);
}
function _sendUCSCVisitInterest() {
    _sendUCSCVisitInterest = (0,_async_to_generator/* default */.Z)(function(transactionId, param) {
        var contactId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contactId = param.contactId;
                    return [
                        4,
                        (0,api_gluglu_open/* initApi */.g8)().potentialPropertyVisitInterest(transactionId, {
                            contact_id: contactId,
                            tenant_id: constants/* TENANTS.ucsc */.rk.ucsc
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _sendUCSCVisitInterest.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/context/BottomSheetContext.tsx + 2 modules
var BottomSheetContext = __webpack_require__(88628);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: src/design-lib/style-theme/theme.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/theme.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA42UyW6cQBCG73mKkrgkkomo3rtyAhpeI5rxvg4ez9jYUd49KkY5dLWRLDh91PL331XQfrc7wJ9vAHX9Gx+PN+HpviGoxnG0Q/yVcVx4cq3NuVp4F5zKuV54jDjm3BBUgwst9jm3Cx/6ocu5I6hi12HX5NwTVBa99ybngaBqnE5a6I/MrUY15HzDfeMYR5fzLUHVhsGlNufnBJVzyXTiXBcElbI9tjrnlwQVDrENwp8rgiq50Y6izjX75kY3Ys5vTvcyyvhb5pafnN/xuQI/Ob/nviaZJHQ+EFSd7nQndD4SVF577QV/Yv+VVVbo3PF5EyYU9zgxVxhQ+P/M+psxDoLv2X+TYhT+vxBUwfbJi/s98L34vrE+50fWmdpkRP3XRX9sjbj3t5PPcRDzOZ/mPwZR533hfXJCz8eJN0b4jM0y6G3SogHyhvV9bLVQhMuKpWGQFuGyYzq20iNclmz0UZqEy5Z11kuX0C1jYQZpE/Kedb1x0icMKwOJce0Psln5JeB2LeN8ZZjwYmVL8HIt42pljvF67cPNyoTj7VqPu5VZxvuVIcQHggbcNIMy0wwN7K+3m+8qnvHrz5qf+odIeOQENc0Qvhb/xPFcG93XEnacgNMMXxQ0ETTTLOAzQW1CgfcEtTMFfiGoQ1nkQFBHV+AjQa3KIq8ENZbRbxxd1p65ZUHfuYYq8AdBrQusGj5kQZEbFlQRlH4oTVDaoQxB6YayBKUZyhFsjoedoJ6gdEgFgtIgFQlKf9SGoJS7JSjdUecEn5hzQVAquCQoI6/+y/r7Dy2XybuPCAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(19636);
;// CONCATENATED MODULE: ./src/design-lib/style-theme/tenant/ucscTheme.css.ts

var ucscThemeStyle = {'--_1muh8nk0':'#FFF5E9','--_1muh8nk1':'#FFD6A5','--_1muh8nk2':'#FFB862','--_1muh8nk3':'#FF991F','--_1muh8nk4':'#E68A1C','--_1muh8nk5':'#E6ECEB','--_1muh8nk6':'#9BB1B0','--_1muh8nk7':'#517774','--_1muh8nk8':'#063D39','--_1muh8nk9':'#05312E','--_1muh8nka':'#E9F9F6','--_1muh8nkb':'#A8E6DA','--_1muh8nkc':'#66D4BF','--_1muh8nkd':'#25C1A3','--_1muh8nke':'#1E9A82','--_1muh8nkf':'#D6F5FF','--_1muh8nkg':'#F6F6F1','--_1muh8nkh':'#FFFFFF','--_1muh8nki':'#F5F5F5','--_1muh8nkj':'#E8E8E8','--_1muh8nkk':'#D4D4D3','--_1muh8nkl':'#B3B3B2','--_1muh8nkm':'#737372','--_1muh8nkn':'#525251','--_1muh8nko':'#1D1D1B','--_1muh8nkp':'#12181E','--_1muh8nkq':'#F0F9EE','--_1muh8nkr':'#A4D99A','--_1muh8nks':'#85CD79','--_1muh8nkt':'#67C057','--_1muh8nku':'#5DAD4E','--_1muh8nkv':'#529A46','--_1muh8nkw':'#FFF9EC','--_1muh8nkx':'#FFD98E','--_1muh8nky':'#FFCD69','--_1muh8nkz':'#FFC043','--_1muh8nk10':'#E6AD3C','--_1muh8nk11':'#CC9A36','--_1muh8nk12':'#FDEEEE','--_1muh8nk13':'#F39A9A','--_1muh8nk14':'#EF7979','--_1muh8nk15':'#EB5757','--_1muh8nk16':'#D44E4E','--_1muh8nk17':'#BC4646','--_1muh8nk18':'#FFFFFF','--_1muh8nk19':'#E7F8FB','--_1muh8nk1a':'#007A91','--_1muh8nk1b':'#F5F5F5','--_1muh8nk1c':'#FFFFFF','--_1muh8nk1d':'#F5F5F5','--_1muh8nk1e':'#007A91','--_1muh8nk1f':'#007A91','--_1muh8nk1g':'#007A91','--_1muh8nk1h':'#007A91','--_1muh8nk1i':'#007A91','--_1muh8nk1j':'#E7F8FB','--_1muh8nk1k':'#006375','--_1muh8nk1l':'0 6px 24px 0 rgba(29,29,27,0.3)','--_1muh8nk1m':'0 2px 8px 0 rgba(29,29,27,0.3)','--_1muh8nk1n':'0 4px 16px 0 rgba(29,29,27,0.3)','--_1muh8nk1o':'0 1px 4px 0 rgba(29,29,27,0.3)','--_1muh8nk1p':'0px','--_1muh8nk1q':'-48px','--_1muh8nk1r':'-64px','--_1muh8nk1s':'-80px','--_1muh8nk1t':'-96px','--_1muh8nk1u':'-24px','--_1muh8nk1v':'-16px','--_1muh8nk1w':'-20px','--_1muh8nk1x':'-8px','--_1muh8nk1y':'-12px','--_1muh8nk1z':'-32px','--_1muh8nk20':'-4px','--_1muh8nk21':'-2px','--_1muh8nk22':'48px','--_1muh8nk23':'64px','--_1muh8nk24':'80px','--_1muh8nk25':'96px','--_1muh8nk26':'auto','--_1muh8nk27':'24px','--_1muh8nk28':'16px','--_1muh8nk29':'20px','--_1muh8nk2a':'8px','--_1muh8nk2b':'12px','--_1muh8nk2c':'32px','--_1muh8nk2d':'4px','--_1muh8nk2e':'2px','--_1muh8nk2f':'0px'};
;// CONCATENATED MODULE: ./src/context/TenantProvider.tsx




var TenantContext = /*#__PURE__*/ (0,react.createContext)({
    tenant: constants/* TENANTS.casavo */.rk.casavo
});
var TenantContextProvider = function(param) {
    var children = param.children, tenant = param.tenant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TenantContext.Provider, {
        value: {
            tenant: tenant
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: tenant === constants/* TENANTS.ucsc */.rk.ucsc ? ucscThemeStyle : undefined,
            children: children
        })
    });
};
var useCurrentTenant = function() {
    return (0,react.useContext)(TenantContext).tenant;
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: src/design-lib/components/Button/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/components/Button/styles.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA7VWbY+iMBD+7q9oYjbRREyLom73y+XOvT9xuWwKFKhCS0rxZS/73y8UdMuLuhjXamLKzDPTZ2bK82NLj4EkCc3A22zHE3jcgn8DAAIpEv0HACUJzwIhEwykUETREfRpOH4ZAPAxAECJi3azhWH5MZhWEZB2sPbU3TJlKZJaEQujmIWRsjwRC4mBDF0yghO9tL8rpE+lJYnP8gyDeXoodgPBlbWnhScGCwiLvZCkGKzK5zolppjgGJA4BtNZBijJ6IuZDfZZRtyY+jqtKoHhcracLe26YSC8PMNcqNGfk8/fsfYSuYoZpxhA08PWzxqpO/DJtHG1TVSdwakOljBu7Zmvos8tfdaMvVMM0NR2JE1MGK8GM1+1YE5bJkwDw69jwDYGvIlBayT+1h9dP+JtQyly7p9KvCNyZFlvKMmjFd8iOq7BXOH6JlRQdczByiLiiz0GUC+UHsAQ2WiFXuuxIrGj8r5YYSNt4im2o/dhRQ2sWl+2vYevq2KZPkGNfbRGa/Szm/1zaQznXpyfo3cxbXczHfRiuut8/fgdrufr+XpmIoRfZkjfHSmRlKtr7VQhGBF60agvOvt5UnyXEziFTr/mDXtR2hnNBOtFbxMNNcDq/dt9ovY1G126QboB2n0c3VEAx5mcfldqYJsBL1360R0VaYc38e4oSg0QNQFvFMbuLgy7b3QMgO+cjNYcskdOBnvkZLDriqMHo5svv20vAXzbrFwYzs2Dp2Pz6OnYPKw4pX4mnCWkVKBngQ2ni1KHWiJXgPGAcaZoHbzjBaRlpCuUEgnWQ5qJmPkX7GIaqNtWJ1GKYKFKP7dLCXjLW4nUNPJyWRj8Klg5NwV7ZzzEn9lrAemzLI3JEQM3Ft72xVCdtl1KzDJ9j8TeyIFPwAJomR50qxVXrnUWqYvSvBKopffHf3OrwwnVDAAA"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(2653);
// EXTERNAL MODULE: ./node_modules/@vanilla-extract/recipes/createRuntimeFn/dist/vanilla-extract-recipes-createRuntimeFn.esm.js
var vanilla_extract_recipes_createRuntimeFn_esm = __webpack_require__(83331);
// EXTERNAL MODULE: ./node_modules/@vanilla-extract/sprinkles/createRuntimeSprinkles/dist/vanilla-extract-sprinkles-createRuntimeSprinkles.esm.js + 1 modules
var vanilla_extract_sprinkles_createRuntimeSprinkles_esm = __webpack_require__(27861);
;// CONCATENATED MODULE: ./src/design-lib/components/Button/styles.css.ts




var styles_css_button = (0,vanilla_extract_recipes_createRuntimeFn_esm/* createRuntimeFn */.u)({defaultClassName:'_3vnm0y1 tfghjghi tfghjgio tfghjg6 tfghjg1u tfghjgac tfghjglf',variantClassNames:{color:{dark:'_3vnm0y4',light:'_3vnm0y5'},style:{primary:'_3vnm0y6',secondary:'_3vnm0y7',tertiary:'_3vnm0y8'},shape:{'default':'_3vnm0y9',round:'_3vnm0y2'},size:{big:'_3vnm0yb',medium:'_3vnm0yc',small:'_3vnm0yd'}},defaultVariants:{color:'dark',style:'primary',shape:'default',size:'medium'},compoundVariants:[[{color:'dark',style:'primary'},'_3vnm0ye'],[{color:'light',style:'primary'},'_3vnm0yf'],[{color:'dark',style:'secondary'},'_3vnm0yg'],[{color:'light',style:'secondary'},'_3vnm0yh'],[{color:'dark',style:'tertiary'},'_3vnm0yi'],[{color:'light',style:'tertiary'},'_3vnm0yj']]});
var loadingAnimation = '_3vnm0ym tfghjg20';
var sprinkles = (0,vanilla_extract_sprinkles_createRuntimeSprinkles_esm/* createSprinkles */.$)({conditions:{defaultCondition:'mobile',conditionNames:['mobile','tablet','desktop'],responsiveArray:undefined},styles:{margin:{values:{'0 auto':{conditions:{mobile:'tfghjgbr',tablet:'tfghjgbs',desktop:'tfghjgbt'},defaultClass:'tfghjgbr'},auto:{conditions:{mobile:'tfghjgbu',tablet:'tfghjgbv',desktop:'tfghjgbw'},defaultClass:'tfghjgbu'}}},padding:{mappings:['paddingTop','paddingBottom','paddingLeft','paddingRight']},marginX:{mappings:['marginLeft','marginRight']},marginY:{mappings:['marginTop','marginBottom']},paddingX:{mappings:['paddingLeft','paddingRight']},paddingY:{mappings:['paddingTop','paddingBottom']},alignItems:{values:{'flex-start':{conditions:{mobile:'tfghjg0',tablet:'tfghjg1',desktop:'tfghjg2'},defaultClass:'tfghjg0'},'flex-end':{conditions:{mobile:'tfghjg3',tablet:'tfghjg4',desktop:'tfghjg5'},defaultClass:'tfghjg3'},center:{conditions:{mobile:'tfghjg6',tablet:'tfghjg7',desktop:'tfghjg8'},defaultClass:'tfghjg6'}}},alignSelf:{values:{'flex-start':{conditions:{mobile:'tfghjg9',tablet:'tfghjga',desktop:'tfghjgb'},defaultClass:'tfghjg9'},'flex-end':{conditions:{mobile:'tfghjgc',tablet:'tfghjgd',desktop:'tfghjge'},defaultClass:'tfghjgc'},center:{conditions:{mobile:'tfghjgf',tablet:'tfghjgg',desktop:'tfghjgh'},defaultClass:'tfghjgf'}}},border:{values:{'0':{conditions:{mobile:'tfghjgi',tablet:'tfghjgj',desktop:'tfghjgk'},defaultClass:'tfghjgi'}}},borderRadius:{values:{'0':{conditions:{mobile:'tfghjgl',tablet:'tfghjgm',desktop:'tfghjgn'},defaultClass:'tfghjgl'},'4':{conditions:{mobile:'tfghjgo',tablet:'tfghjgp',desktop:'tfghjgq'},defaultClass:'tfghjgo'},'8':{conditions:{mobile:'tfghjgr',tablet:'tfghjgs',desktop:'tfghjgt'},defaultClass:'tfghjgr'},'16':{conditions:{mobile:'tfghjgu',tablet:'tfghjgv',desktop:'tfghjgw'},defaultClass:'tfghjgu'},'24':{conditions:{mobile:'tfghjgx',tablet:'tfghjgy',desktop:'tfghjgz'},defaultClass:'tfghjgx'}}},borderBottomLeftRadius:{values:{'4':{conditions:{mobile:'tfghjg10',tablet:'tfghjg11',desktop:'tfghjg12'},defaultClass:'tfghjg10'},'8':{conditions:{mobile:'tfghjg13',tablet:'tfghjg14',desktop:'tfghjg15'},defaultClass:'tfghjg13'},'16':{conditions:{mobile:'tfghjg16',tablet:'tfghjg17',desktop:'tfghjg18'},defaultClass:'tfghjg16'},'24':{conditions:{mobile:'tfghjg19',tablet:'tfghjg1a',desktop:'tfghjg1b'},defaultClass:'tfghjg19'}}},borderTopRightRadius:{values:{'0':{conditions:{mobile:'tfghjg1c',tablet:'tfghjg1d',desktop:'tfghjg1e'},defaultClass:'tfghjg1c'},'4':{conditions:{mobile:'tfghjg1f',tablet:'tfghjg1g',desktop:'tfghjg1h'},defaultClass:'tfghjg1f'},'8':{conditions:{mobile:'tfghjg1i',tablet:'tfghjg1j',desktop:'tfghjg1k'},defaultClass:'tfghjg1i'},'16':{conditions:{mobile:'tfghjg1l',tablet:'tfghjg1m',desktop:'tfghjg1n'},defaultClass:'tfghjg1l'},'24':{conditions:{mobile:'tfghjg1o',tablet:'tfghjg1p',desktop:'tfghjg1q'},defaultClass:'tfghjg1o'}}},display:{values:{none:{conditions:{mobile:'tfghjg1r',tablet:'tfghjg1s',desktop:'tfghjg1t'},defaultClass:'tfghjg1r'},flex:{conditions:{mobile:'tfghjg1u',tablet:'tfghjg1v',desktop:'tfghjg1w'},defaultClass:'tfghjg1u'},grid:{conditions:{mobile:'tfghjg1x',tablet:'tfghjg1y',desktop:'tfghjg1z'},defaultClass:'tfghjg1x'},block:{conditions:{mobile:'tfghjg20',tablet:'tfghjg21',desktop:'tfghjg22'},defaultClass:'tfghjg20'},'inline-block':{conditions:{mobile:'tfghjg23',tablet:'tfghjg24',desktop:'tfghjg25'},defaultClass:'tfghjg23'}}},position:{values:{'static':{conditions:{mobile:'tfghjg26',tablet:'tfghjg27',desktop:'tfghjg28'},defaultClass:'tfghjg26'},absolute:{conditions:{mobile:'tfghjg29',tablet:'tfghjg2a',desktop:'tfghjg2b'},defaultClass:'tfghjg29'},relative:{conditions:{mobile:'tfghjg2c',tablet:'tfghjg2d',desktop:'tfghjg2e'},defaultClass:'tfghjg2c'}}},top:{values:{'0':{conditions:{mobile:'tfghjg2f',tablet:'tfghjg2g',desktop:'tfghjg2h'},defaultClass:'tfghjg2f'},'2xl':{conditions:{mobile:'tfghjg2i',tablet:'tfghjg2j',desktop:'tfghjg2k'},defaultClass:'tfghjg2i'},'3xl':{conditions:{mobile:'tfghjg2l',tablet:'tfghjg2m',desktop:'tfghjg2n'},defaultClass:'tfghjg2l'},'4xl':{conditions:{mobile:'tfghjg2o',tablet:'tfghjg2p',desktop:'tfghjg2q'},defaultClass:'tfghjg2o'},'5xl':{conditions:{mobile:'tfghjg2r',tablet:'tfghjg2s',desktop:'tfghjg2t'},defaultClass:'tfghjg2r'},auto:{conditions:{mobile:'tfghjg2u',tablet:'tfghjg2v',desktop:'tfghjg2w'},defaultClass:'tfghjg2u'},l:{conditions:{mobile:'tfghjg2x',tablet:'tfghjg2y',desktop:'tfghjg2z'},defaultClass:'tfghjg2x'},m:{conditions:{mobile:'tfghjg30',tablet:'tfghjg31',desktop:'tfghjg32'},defaultClass:'tfghjg30'},'m-l':{conditions:{mobile:'tfghjg33',tablet:'tfghjg34',desktop:'tfghjg35'},defaultClass:'tfghjg33'},s:{conditions:{mobile:'tfghjg36',tablet:'tfghjg37',desktop:'tfghjg38'},defaultClass:'tfghjg36'},'s-m':{conditions:{mobile:'tfghjg39',tablet:'tfghjg3a',desktop:'tfghjg3b'},defaultClass:'tfghjg39'},xl:{conditions:{mobile:'tfghjg3c',tablet:'tfghjg3d',desktop:'tfghjg3e'},defaultClass:'tfghjg3c'},xs:{conditions:{mobile:'tfghjg3f',tablet:'tfghjg3g',desktop:'tfghjg3h'},defaultClass:'tfghjg3f'},xxs:{conditions:{mobile:'tfghjg3i',tablet:'tfghjg3j',desktop:'tfghjg3k'},defaultClass:'tfghjg3i'}}},right:{values:{'0':{conditions:{mobile:'tfghjg3l',tablet:'tfghjg3m',desktop:'tfghjg3n'},defaultClass:'tfghjg3l'},'2xl':{conditions:{mobile:'tfghjg3o',tablet:'tfghjg3p',desktop:'tfghjg3q'},defaultClass:'tfghjg3o'},'3xl':{conditions:{mobile:'tfghjg3r',tablet:'tfghjg3s',desktop:'tfghjg3t'},defaultClass:'tfghjg3r'},'4xl':{conditions:{mobile:'tfghjg3u',tablet:'tfghjg3v',desktop:'tfghjg3w'},defaultClass:'tfghjg3u'},'5xl':{conditions:{mobile:'tfghjg3x',tablet:'tfghjg3y',desktop:'tfghjg3z'},defaultClass:'tfghjg3x'},auto:{conditions:{mobile:'tfghjg40',tablet:'tfghjg41',desktop:'tfghjg42'},defaultClass:'tfghjg40'},l:{conditions:{mobile:'tfghjg43',tablet:'tfghjg44',desktop:'tfghjg45'},defaultClass:'tfghjg43'},m:{conditions:{mobile:'tfghjg46',tablet:'tfghjg47',desktop:'tfghjg48'},defaultClass:'tfghjg46'},'m-l':{conditions:{mobile:'tfghjg49',tablet:'tfghjg4a',desktop:'tfghjg4b'},defaultClass:'tfghjg49'},s:{conditions:{mobile:'tfghjg4c',tablet:'tfghjg4d',desktop:'tfghjg4e'},defaultClass:'tfghjg4c'},'s-m':{conditions:{mobile:'tfghjg4f',tablet:'tfghjg4g',desktop:'tfghjg4h'},defaultClass:'tfghjg4f'},xl:{conditions:{mobile:'tfghjg4i',tablet:'tfghjg4j',desktop:'tfghjg4k'},defaultClass:'tfghjg4i'},xs:{conditions:{mobile:'tfghjg4l',tablet:'tfghjg4m',desktop:'tfghjg4n'},defaultClass:'tfghjg4l'},xxs:{conditions:{mobile:'tfghjg4o',tablet:'tfghjg4p',desktop:'tfghjg4q'},defaultClass:'tfghjg4o'}}},bottom:{values:{'0':{conditions:{mobile:'tfghjg4r',tablet:'tfghjg4s',desktop:'tfghjg4t'},defaultClass:'tfghjg4r'},'2xl':{conditions:{mobile:'tfghjg4u',tablet:'tfghjg4v',desktop:'tfghjg4w'},defaultClass:'tfghjg4u'},'3xl':{conditions:{mobile:'tfghjg4x',tablet:'tfghjg4y',desktop:'tfghjg4z'},defaultClass:'tfghjg4x'},'4xl':{conditions:{mobile:'tfghjg50',tablet:'tfghjg51',desktop:'tfghjg52'},defaultClass:'tfghjg50'},'5xl':{conditions:{mobile:'tfghjg53',tablet:'tfghjg54',desktop:'tfghjg55'},defaultClass:'tfghjg53'},auto:{conditions:{mobile:'tfghjg56',tablet:'tfghjg57',desktop:'tfghjg58'},defaultClass:'tfghjg56'},l:{conditions:{mobile:'tfghjg59',tablet:'tfghjg5a',desktop:'tfghjg5b'},defaultClass:'tfghjg59'},m:{conditions:{mobile:'tfghjg5c',tablet:'tfghjg5d',desktop:'tfghjg5e'},defaultClass:'tfghjg5c'},'m-l':{conditions:{mobile:'tfghjg5f',tablet:'tfghjg5g',desktop:'tfghjg5h'},defaultClass:'tfghjg5f'},s:{conditions:{mobile:'tfghjg5i',tablet:'tfghjg5j',desktop:'tfghjg5k'},defaultClass:'tfghjg5i'},'s-m':{conditions:{mobile:'tfghjg5l',tablet:'tfghjg5m',desktop:'tfghjg5n'},defaultClass:'tfghjg5l'},xl:{conditions:{mobile:'tfghjg5o',tablet:'tfghjg5p',desktop:'tfghjg5q'},defaultClass:'tfghjg5o'},xs:{conditions:{mobile:'tfghjg5r',tablet:'tfghjg5s',desktop:'tfghjg5t'},defaultClass:'tfghjg5r'},xxs:{conditions:{mobile:'tfghjg5u',tablet:'tfghjg5v',desktop:'tfghjg5w'},defaultClass:'tfghjg5u'}}},left:{values:{'0':{conditions:{mobile:'tfghjg5x',tablet:'tfghjg5y',desktop:'tfghjg5z'},defaultClass:'tfghjg5x'},'2xl':{conditions:{mobile:'tfghjg60',tablet:'tfghjg61',desktop:'tfghjg62'},defaultClass:'tfghjg60'},'3xl':{conditions:{mobile:'tfghjg63',tablet:'tfghjg64',desktop:'tfghjg65'},defaultClass:'tfghjg63'},'4xl':{conditions:{mobile:'tfghjg66',tablet:'tfghjg67',desktop:'tfghjg68'},defaultClass:'tfghjg66'},'5xl':{conditions:{mobile:'tfghjg69',tablet:'tfghjg6a',desktop:'tfghjg6b'},defaultClass:'tfghjg69'},auto:{conditions:{mobile:'tfghjg6c',tablet:'tfghjg6d',desktop:'tfghjg6e'},defaultClass:'tfghjg6c'},l:{conditions:{mobile:'tfghjg6f',tablet:'tfghjg6g',desktop:'tfghjg6h'},defaultClass:'tfghjg6f'},m:{conditions:{mobile:'tfghjg6i',tablet:'tfghjg6j',desktop:'tfghjg6k'},defaultClass:'tfghjg6i'},'m-l':{conditions:{mobile:'tfghjg6l',tablet:'tfghjg6m',desktop:'tfghjg6n'},defaultClass:'tfghjg6l'},s:{conditions:{mobile:'tfghjg6o',tablet:'tfghjg6p',desktop:'tfghjg6q'},defaultClass:'tfghjg6o'},'s-m':{conditions:{mobile:'tfghjg6r',tablet:'tfghjg6s',desktop:'tfghjg6t'},defaultClass:'tfghjg6r'},xl:{conditions:{mobile:'tfghjg6u',tablet:'tfghjg6v',desktop:'tfghjg6w'},defaultClass:'tfghjg6u'},xs:{conditions:{mobile:'tfghjg6x',tablet:'tfghjg6y',desktop:'tfghjg6z'},defaultClass:'tfghjg6x'},xxs:{conditions:{mobile:'tfghjg70',tablet:'tfghjg71',desktop:'tfghjg72'},defaultClass:'tfghjg70'}}},flex:{values:{'1':{conditions:{mobile:'tfghjg73',tablet:'tfghjg74',desktop:'tfghjg75'},defaultClass:'tfghjg73'}}},flexBasis:{values:{'100%':{conditions:{mobile:'tfghjg76',tablet:'tfghjg77',desktop:'tfghjg78'},defaultClass:'tfghjg76'},'50%':{conditions:{mobile:'tfghjg79',tablet:'tfghjg7a',desktop:'tfghjg7b'},defaultClass:'tfghjg79'},unset:{conditions:{mobile:'tfghjg7c',tablet:'tfghjg7d',desktop:'tfghjg7e'},defaultClass:'tfghjg7c'}}},flexDirection:{values:{'row-reverse':{conditions:{mobile:'tfghjg7f',tablet:'tfghjg7g',desktop:'tfghjg7h'},defaultClass:'tfghjg7f'},row:{conditions:{mobile:'tfghjg7i',tablet:'tfghjg7j',desktop:'tfghjg7k'},defaultClass:'tfghjg7i'},column:{conditions:{mobile:'tfghjg7l',tablet:'tfghjg7m',desktop:'tfghjg7n'},defaultClass:'tfghjg7l'}}},flexGrow:{values:{'0':{conditions:{mobile:'tfghjg7r',tablet:'tfghjg7s',desktop:'tfghjg7t'},defaultClass:'tfghjg7r'},'1':{conditions:{mobile:'tfghjg7o',tablet:'tfghjg7p',desktop:'tfghjg7q'},defaultClass:'tfghjg7o'}}},flexShrink:{values:{'0':{conditions:{mobile:'tfghjg7x',tablet:'tfghjg7y',desktop:'tfghjg7z'},defaultClass:'tfghjg7x'},'1':{conditions:{mobile:'tfghjg7u',tablet:'tfghjg7v',desktop:'tfghjg7w'},defaultClass:'tfghjg7u'}}},flexWrap:{values:{wrap:{conditions:{mobile:'tfghjg80',tablet:'tfghjg81',desktop:'tfghjg82'},defaultClass:'tfghjg80'},nowrap:{conditions:{mobile:'tfghjg83',tablet:'tfghjg84',desktop:'tfghjg85'},defaultClass:'tfghjg83'}}},fontWeight:{values:{'300':{conditions:{mobile:'tfghjg86',tablet:'tfghjg87',desktop:'tfghjg88'},defaultClass:'tfghjg86'},'400':{conditions:{mobile:'tfghjg89',tablet:'tfghjg8a',desktop:'tfghjg8b'},defaultClass:'tfghjg89'},'600':{conditions:{mobile:'tfghjg8c',tablet:'tfghjg8d',desktop:'tfghjg8e'},defaultClass:'tfghjg8c'}}},cursor:{values:{pointer:{conditions:{mobile:'tfghjg8f',tablet:'tfghjg8g',desktop:'tfghjg8h'},defaultClass:'tfghjg8f'},'not-allowed':{conditions:{mobile:'tfghjg8i',tablet:'tfghjg8j',desktop:'tfghjg8k'},defaultClass:'tfghjg8i'}}},textDecoration:{values:{underline:{conditions:{mobile:'tfghjg8l',tablet:'tfghjg8m',desktop:'tfghjg8n'},defaultClass:'tfghjg8l'}}},verticalAlign:{values:{baseline:{conditions:{mobile:'tfghjg8o',tablet:'tfghjg8p',desktop:'tfghjg8q'},defaultClass:'tfghjg8o'},center:{conditions:{mobile:'tfghjg8r',tablet:'tfghjg8s',desktop:'tfghjg8t'},defaultClass:'tfghjg8r'}}},gap:{values:{'0':{conditions:{mobile:'tfghjg8u',tablet:'tfghjg8v',desktop:'tfghjg8w'},defaultClass:'tfghjg8u'},'2xl':{conditions:{mobile:'tfghjg8x',tablet:'tfghjg8y',desktop:'tfghjg8z'},defaultClass:'tfghjg8x'},'3xl':{conditions:{mobile:'tfghjg90',tablet:'tfghjg91',desktop:'tfghjg92'},defaultClass:'tfghjg90'},'4xl':{conditions:{mobile:'tfghjg93',tablet:'tfghjg94',desktop:'tfghjg95'},defaultClass:'tfghjg93'},'5xl':{conditions:{mobile:'tfghjg96',tablet:'tfghjg97',desktop:'tfghjg98'},defaultClass:'tfghjg96'},auto:{conditions:{mobile:'tfghjg99',tablet:'tfghjg9a',desktop:'tfghjg9b'},defaultClass:'tfghjg99'},l:{conditions:{mobile:'tfghjg9c',tablet:'tfghjg9d',desktop:'tfghjg9e'},defaultClass:'tfghjg9c'},m:{conditions:{mobile:'tfghjg9f',tablet:'tfghjg9g',desktop:'tfghjg9h'},defaultClass:'tfghjg9f'},'m-l':{conditions:{mobile:'tfghjg9i',tablet:'tfghjg9j',desktop:'tfghjg9k'},defaultClass:'tfghjg9i'},s:{conditions:{mobile:'tfghjg9l',tablet:'tfghjg9m',desktop:'tfghjg9n'},defaultClass:'tfghjg9l'},'s-m':{conditions:{mobile:'tfghjg9o',tablet:'tfghjg9p',desktop:'tfghjg9q'},defaultClass:'tfghjg9o'},xl:{conditions:{mobile:'tfghjg9r',tablet:'tfghjg9s',desktop:'tfghjg9t'},defaultClass:'tfghjg9r'},xs:{conditions:{mobile:'tfghjg9u',tablet:'tfghjg9v',desktop:'tfghjg9w'},defaultClass:'tfghjg9u'},xxs:{conditions:{mobile:'tfghjg9x',tablet:'tfghjg9y',desktop:'tfghjg9z'},defaultClass:'tfghjg9x'}}},height:{values:{'100vh':{conditions:{mobile:'tfghjga0',tablet:'tfghjga1',desktop:'tfghjga2'},defaultClass:'tfghjga0'},'100%':{conditions:{mobile:'tfghjga3',tablet:'tfghjga4',desktop:'tfghjga5'},defaultClass:'tfghjga3'}}},justifyContent:{values:{'space-between':{conditions:{mobile:'tfghjga6',tablet:'tfghjga7',desktop:'tfghjga8'},defaultClass:'tfghjga6'},'space-around':{conditions:{mobile:'tfghjga9',tablet:'tfghjgaa',desktop:'tfghjgab'},defaultClass:'tfghjga9'},center:{conditions:{mobile:'tfghjgac',tablet:'tfghjgad',desktop:'tfghjgae'},defaultClass:'tfghjgac'},'flex-end':{conditions:{mobile:'tfghjgaf',tablet:'tfghjgag',desktop:'tfghjgah'},defaultClass:'tfghjgaf'},'flex-start':{conditions:{mobile:'tfghjgai',tablet:'tfghjgaj',desktop:'tfghjgak'},defaultClass:'tfghjgai'}}},marginBottom:{values:{'0':{conditions:{mobile:'tfghjgal',tablet:'tfghjgam',desktop:'tfghjgan'},defaultClass:'tfghjgal'},'2xl':{conditions:{mobile:'tfghjgao',tablet:'tfghjgap',desktop:'tfghjgaq'},defaultClass:'tfghjgao'},'3xl':{conditions:{mobile:'tfghjgar',tablet:'tfghjgas',desktop:'tfghjgat'},defaultClass:'tfghjgar'},'4xl':{conditions:{mobile:'tfghjgau',tablet:'tfghjgav',desktop:'tfghjgaw'},defaultClass:'tfghjgau'},'5xl':{conditions:{mobile:'tfghjgax',tablet:'tfghjgay',desktop:'tfghjgaz'},defaultClass:'tfghjgax'},auto:{conditions:{mobile:'tfghjgb0',tablet:'tfghjgb1',desktop:'tfghjgb2'},defaultClass:'tfghjgb0'},l:{conditions:{mobile:'tfghjgb3',tablet:'tfghjgb4',desktop:'tfghjgb5'},defaultClass:'tfghjgb3'},m:{conditions:{mobile:'tfghjgb6',tablet:'tfghjgb7',desktop:'tfghjgb8'},defaultClass:'tfghjgb6'},'m-l':{conditions:{mobile:'tfghjgb9',tablet:'tfghjgba',desktop:'tfghjgbb'},defaultClass:'tfghjgb9'},s:{conditions:{mobile:'tfghjgbc',tablet:'tfghjgbd',desktop:'tfghjgbe'},defaultClass:'tfghjgbc'},'s-m':{conditions:{mobile:'tfghjgbf',tablet:'tfghjgbg',desktop:'tfghjgbh'},defaultClass:'tfghjgbf'},xl:{conditions:{mobile:'tfghjgbi',tablet:'tfghjgbj',desktop:'tfghjgbk'},defaultClass:'tfghjgbi'},xs:{conditions:{mobile:'tfghjgbl',tablet:'tfghjgbm',desktop:'tfghjgbn'},defaultClass:'tfghjgbl'},xxs:{conditions:{mobile:'tfghjgbo',tablet:'tfghjgbp',desktop:'tfghjgbq'},defaultClass:'tfghjgbo'}}},marginLeft:{values:{'0':{conditions:{mobile:'tfghjgbx',tablet:'tfghjgby',desktop:'tfghjgbz'},defaultClass:'tfghjgbx'},'2xl':{conditions:{mobile:'tfghjgc0',tablet:'tfghjgc1',desktop:'tfghjgc2'},defaultClass:'tfghjgc0'},'3xl':{conditions:{mobile:'tfghjgc3',tablet:'tfghjgc4',desktop:'tfghjgc5'},defaultClass:'tfghjgc3'},'4xl':{conditions:{mobile:'tfghjgc6',tablet:'tfghjgc7',desktop:'tfghjgc8'},defaultClass:'tfghjgc6'},'5xl':{conditions:{mobile:'tfghjgc9',tablet:'tfghjgca',desktop:'tfghjgcb'},defaultClass:'tfghjgc9'},auto:{conditions:{mobile:'tfghjgcc',tablet:'tfghjgcd',desktop:'tfghjgce'},defaultClass:'tfghjgcc'},l:{conditions:{mobile:'tfghjgcf',tablet:'tfghjgcg',desktop:'tfghjgch'},defaultClass:'tfghjgcf'},m:{conditions:{mobile:'tfghjgci',tablet:'tfghjgcj',desktop:'tfghjgck'},defaultClass:'tfghjgci'},'m-l':{conditions:{mobile:'tfghjgcl',tablet:'tfghjgcm',desktop:'tfghjgcn'},defaultClass:'tfghjgcl'},s:{conditions:{mobile:'tfghjgco',tablet:'tfghjgcp',desktop:'tfghjgcq'},defaultClass:'tfghjgco'},'s-m':{conditions:{mobile:'tfghjgcr',tablet:'tfghjgcs',desktop:'tfghjgct'},defaultClass:'tfghjgcr'},xl:{conditions:{mobile:'tfghjgcu',tablet:'tfghjgcv',desktop:'tfghjgcw'},defaultClass:'tfghjgcu'},xs:{conditions:{mobile:'tfghjgcx',tablet:'tfghjgcy',desktop:'tfghjgcz'},defaultClass:'tfghjgcx'},xxs:{conditions:{mobile:'tfghjgd0',tablet:'tfghjgd1',desktop:'tfghjgd2'},defaultClass:'tfghjgd0'}}},marginRight:{values:{'0':{conditions:{mobile:'tfghjgd3',tablet:'tfghjgd4',desktop:'tfghjgd5'},defaultClass:'tfghjgd3'},'2xl':{conditions:{mobile:'tfghjgd6',tablet:'tfghjgd7',desktop:'tfghjgd8'},defaultClass:'tfghjgd6'},'3xl':{conditions:{mobile:'tfghjgd9',tablet:'tfghjgda',desktop:'tfghjgdb'},defaultClass:'tfghjgd9'},'4xl':{conditions:{mobile:'tfghjgdc',tablet:'tfghjgdd',desktop:'tfghjgde'},defaultClass:'tfghjgdc'},'5xl':{conditions:{mobile:'tfghjgdf',tablet:'tfghjgdg',desktop:'tfghjgdh'},defaultClass:'tfghjgdf'},auto:{conditions:{mobile:'tfghjgdi',tablet:'tfghjgdj',desktop:'tfghjgdk'},defaultClass:'tfghjgdi'},l:{conditions:{mobile:'tfghjgdl',tablet:'tfghjgdm',desktop:'tfghjgdn'},defaultClass:'tfghjgdl'},m:{conditions:{mobile:'tfghjgdo',tablet:'tfghjgdp',desktop:'tfghjgdq'},defaultClass:'tfghjgdo'},'m-l':{conditions:{mobile:'tfghjgdr',tablet:'tfghjgds',desktop:'tfghjgdt'},defaultClass:'tfghjgdr'},s:{conditions:{mobile:'tfghjgdu',tablet:'tfghjgdv',desktop:'tfghjgdw'},defaultClass:'tfghjgdu'},'s-m':{conditions:{mobile:'tfghjgdx',tablet:'tfghjgdy',desktop:'tfghjgdz'},defaultClass:'tfghjgdx'},xl:{conditions:{mobile:'tfghjge0',tablet:'tfghjge1',desktop:'tfghjge2'},defaultClass:'tfghjge0'},xs:{conditions:{mobile:'tfghjge3',tablet:'tfghjge4',desktop:'tfghjge5'},defaultClass:'tfghjge3'},xxs:{conditions:{mobile:'tfghjge6',tablet:'tfghjge7',desktop:'tfghjge8'},defaultClass:'tfghjge6'}}},marginTop:{values:{'0':{conditions:{mobile:'tfghjge9',tablet:'tfghjgea',desktop:'tfghjgeb'},defaultClass:'tfghjge9'},'2xl':{conditions:{mobile:'tfghjgec',tablet:'tfghjged',desktop:'tfghjgee'},defaultClass:'tfghjgec'},'3xl':{conditions:{mobile:'tfghjgef',tablet:'tfghjgeg',desktop:'tfghjgeh'},defaultClass:'tfghjgef'},'4xl':{conditions:{mobile:'tfghjgei',tablet:'tfghjgej',desktop:'tfghjgek'},defaultClass:'tfghjgei'},'5xl':{conditions:{mobile:'tfghjgel',tablet:'tfghjgem',desktop:'tfghjgen'},defaultClass:'tfghjgel'},auto:{conditions:{mobile:'tfghjgeo',tablet:'tfghjgep',desktop:'tfghjgeq'},defaultClass:'tfghjgeo'},l:{conditions:{mobile:'tfghjger',tablet:'tfghjges',desktop:'tfghjget'},defaultClass:'tfghjger'},m:{conditions:{mobile:'tfghjgeu',tablet:'tfghjgev',desktop:'tfghjgew'},defaultClass:'tfghjgeu'},'m-l':{conditions:{mobile:'tfghjgex',tablet:'tfghjgey',desktop:'tfghjgez'},defaultClass:'tfghjgex'},s:{conditions:{mobile:'tfghjgf0',tablet:'tfghjgf1',desktop:'tfghjgf2'},defaultClass:'tfghjgf0'},'s-m':{conditions:{mobile:'tfghjgf3',tablet:'tfghjgf4',desktop:'tfghjgf5'},defaultClass:'tfghjgf3'},xl:{conditions:{mobile:'tfghjgf6',tablet:'tfghjgf7',desktop:'tfghjgf8'},defaultClass:'tfghjgf6'},xs:{conditions:{mobile:'tfghjgf9',tablet:'tfghjgfa',desktop:'tfghjgfb'},defaultClass:'tfghjgf9'},xxs:{conditions:{mobile:'tfghjgfc',tablet:'tfghjgfd',desktop:'tfghjgfe'},defaultClass:'tfghjgfc'}}},overflow:{values:{hidden:{conditions:{mobile:'tfghjgff',tablet:'tfghjgfg',desktop:'tfghjgfh'},defaultClass:'tfghjgff'},auto:{conditions:{mobile:'tfghjgfi',tablet:'tfghjgfj',desktop:'tfghjgfk'},defaultClass:'tfghjgfi'}}},overflowX:{values:{hidden:{conditions:{mobile:'tfghjgfl',tablet:'tfghjgfm',desktop:'tfghjgfn'},defaultClass:'tfghjgfl'},auto:{conditions:{mobile:'tfghjgfo',tablet:'tfghjgfp',desktop:'tfghjgfq'},defaultClass:'tfghjgfo'}}},paddingBottom:{values:{'0':{conditions:{mobile:'tfghjgfr',tablet:'tfghjgfs',desktop:'tfghjgft'},defaultClass:'tfghjgfr'},'2xl':{conditions:{mobile:'tfghjgfu',tablet:'tfghjgfv',desktop:'tfghjgfw'},defaultClass:'tfghjgfu'},'3xl':{conditions:{mobile:'tfghjgfx',tablet:'tfghjgfy',desktop:'tfghjgfz'},defaultClass:'tfghjgfx'},'4xl':{conditions:{mobile:'tfghjgg0',tablet:'tfghjgg1',desktop:'tfghjgg2'},defaultClass:'tfghjgg0'},'5xl':{conditions:{mobile:'tfghjgg3',tablet:'tfghjgg4',desktop:'tfghjgg5'},defaultClass:'tfghjgg3'},auto:{conditions:{mobile:'tfghjgg6',tablet:'tfghjgg7',desktop:'tfghjgg8'},defaultClass:'tfghjgg6'},l:{conditions:{mobile:'tfghjgg9',tablet:'tfghjgga',desktop:'tfghjggb'},defaultClass:'tfghjgg9'},m:{conditions:{mobile:'tfghjggc',tablet:'tfghjggd',desktop:'tfghjgge'},defaultClass:'tfghjggc'},'m-l':{conditions:{mobile:'tfghjggf',tablet:'tfghjggg',desktop:'tfghjggh'},defaultClass:'tfghjggf'},s:{conditions:{mobile:'tfghjggi',tablet:'tfghjggj',desktop:'tfghjggk'},defaultClass:'tfghjggi'},'s-m':{conditions:{mobile:'tfghjggl',tablet:'tfghjggm',desktop:'tfghjggn'},defaultClass:'tfghjggl'},xl:{conditions:{mobile:'tfghjggo',tablet:'tfghjggp',desktop:'tfghjggq'},defaultClass:'tfghjggo'},xs:{conditions:{mobile:'tfghjggr',tablet:'tfghjggs',desktop:'tfghjggt'},defaultClass:'tfghjggr'},xxs:{conditions:{mobile:'tfghjggu',tablet:'tfghjggv',desktop:'tfghjggw'},defaultClass:'tfghjggu'}}},paddingLeft:{values:{'0':{conditions:{mobile:'tfghjggx',tablet:'tfghjggy',desktop:'tfghjggz'},defaultClass:'tfghjggx'},'2xl':{conditions:{mobile:'tfghjgh0',tablet:'tfghjgh1',desktop:'tfghjgh2'},defaultClass:'tfghjgh0'},'3xl':{conditions:{mobile:'tfghjgh3',tablet:'tfghjgh4',desktop:'tfghjgh5'},defaultClass:'tfghjgh3'},'4xl':{conditions:{mobile:'tfghjgh6',tablet:'tfghjgh7',desktop:'tfghjgh8'},defaultClass:'tfghjgh6'},'5xl':{conditions:{mobile:'tfghjgh9',tablet:'tfghjgha',desktop:'tfghjghb'},defaultClass:'tfghjgh9'},auto:{conditions:{mobile:'tfghjghc',tablet:'tfghjghd',desktop:'tfghjghe'},defaultClass:'tfghjghc'},l:{conditions:{mobile:'tfghjghf',tablet:'tfghjghg',desktop:'tfghjghh'},defaultClass:'tfghjghf'},m:{conditions:{mobile:'tfghjghi',tablet:'tfghjghj',desktop:'tfghjghk'},defaultClass:'tfghjghi'},'m-l':{conditions:{mobile:'tfghjghl',tablet:'tfghjghm',desktop:'tfghjghn'},defaultClass:'tfghjghl'},s:{conditions:{mobile:'tfghjgho',tablet:'tfghjghp',desktop:'tfghjghq'},defaultClass:'tfghjgho'},'s-m':{conditions:{mobile:'tfghjghr',tablet:'tfghjghs',desktop:'tfghjght'},defaultClass:'tfghjghr'},xl:{conditions:{mobile:'tfghjghu',tablet:'tfghjghv',desktop:'tfghjghw'},defaultClass:'tfghjghu'},xs:{conditions:{mobile:'tfghjghx',tablet:'tfghjghy',desktop:'tfghjghz'},defaultClass:'tfghjghx'},xxs:{conditions:{mobile:'tfghjgi0',tablet:'tfghjgi1',desktop:'tfghjgi2'},defaultClass:'tfghjgi0'}}},paddingRight:{values:{'0':{conditions:{mobile:'tfghjgi3',tablet:'tfghjgi4',desktop:'tfghjgi5'},defaultClass:'tfghjgi3'},'2xl':{conditions:{mobile:'tfghjgi6',tablet:'tfghjgi7',desktop:'tfghjgi8'},defaultClass:'tfghjgi6'},'3xl':{conditions:{mobile:'tfghjgi9',tablet:'tfghjgia',desktop:'tfghjgib'},defaultClass:'tfghjgi9'},'4xl':{conditions:{mobile:'tfghjgic',tablet:'tfghjgid',desktop:'tfghjgie'},defaultClass:'tfghjgic'},'5xl':{conditions:{mobile:'tfghjgif',tablet:'tfghjgig',desktop:'tfghjgih'},defaultClass:'tfghjgif'},auto:{conditions:{mobile:'tfghjgii',tablet:'tfghjgij',desktop:'tfghjgik'},defaultClass:'tfghjgii'},l:{conditions:{mobile:'tfghjgil',tablet:'tfghjgim',desktop:'tfghjgin'},defaultClass:'tfghjgil'},m:{conditions:{mobile:'tfghjgio',tablet:'tfghjgip',desktop:'tfghjgiq'},defaultClass:'tfghjgio'},'m-l':{conditions:{mobile:'tfghjgir',tablet:'tfghjgis',desktop:'tfghjgit'},defaultClass:'tfghjgir'},s:{conditions:{mobile:'tfghjgiu',tablet:'tfghjgiv',desktop:'tfghjgiw'},defaultClass:'tfghjgiu'},'s-m':{conditions:{mobile:'tfghjgix',tablet:'tfghjgiy',desktop:'tfghjgiz'},defaultClass:'tfghjgix'},xl:{conditions:{mobile:'tfghjgj0',tablet:'tfghjgj1',desktop:'tfghjgj2'},defaultClass:'tfghjgj0'},xs:{conditions:{mobile:'tfghjgj3',tablet:'tfghjgj4',desktop:'tfghjgj5'},defaultClass:'tfghjgj3'},xxs:{conditions:{mobile:'tfghjgj6',tablet:'tfghjgj7',desktop:'tfghjgj8'},defaultClass:'tfghjgj6'}}},paddingTop:{values:{'0':{conditions:{mobile:'tfghjgj9',tablet:'tfghjgja',desktop:'tfghjgjb'},defaultClass:'tfghjgj9'},'2xl':{conditions:{mobile:'tfghjgjc',tablet:'tfghjgjd',desktop:'tfghjgje'},defaultClass:'tfghjgjc'},'3xl':{conditions:{mobile:'tfghjgjf',tablet:'tfghjgjg',desktop:'tfghjgjh'},defaultClass:'tfghjgjf'},'4xl':{conditions:{mobile:'tfghjgji',tablet:'tfghjgjj',desktop:'tfghjgjk'},defaultClass:'tfghjgji'},'5xl':{conditions:{mobile:'tfghjgjl',tablet:'tfghjgjm',desktop:'tfghjgjn'},defaultClass:'tfghjgjl'},auto:{conditions:{mobile:'tfghjgjo',tablet:'tfghjgjp',desktop:'tfghjgjq'},defaultClass:'tfghjgjo'},l:{conditions:{mobile:'tfghjgjr',tablet:'tfghjgjs',desktop:'tfghjgjt'},defaultClass:'tfghjgjr'},m:{conditions:{mobile:'tfghjgju',tablet:'tfghjgjv',desktop:'tfghjgjw'},defaultClass:'tfghjgju'},'m-l':{conditions:{mobile:'tfghjgjx',tablet:'tfghjgjy',desktop:'tfghjgjz'},defaultClass:'tfghjgjx'},s:{conditions:{mobile:'tfghjgk0',tablet:'tfghjgk1',desktop:'tfghjgk2'},defaultClass:'tfghjgk0'},'s-m':{conditions:{mobile:'tfghjgk3',tablet:'tfghjgk4',desktop:'tfghjgk5'},defaultClass:'tfghjgk3'},xl:{conditions:{mobile:'tfghjgk6',tablet:'tfghjgk7',desktop:'tfghjgk8'},defaultClass:'tfghjgk6'},xs:{conditions:{mobile:'tfghjgk9',tablet:'tfghjgka',desktop:'tfghjgkb'},defaultClass:'tfghjgk9'},xxs:{conditions:{mobile:'tfghjgkc',tablet:'tfghjgkd',desktop:'tfghjgke'},defaultClass:'tfghjgkc'}}},textAlign:{values:{inherit:{conditions:{mobile:'tfghjgkf',tablet:'tfghjgkg',desktop:'tfghjgkh'},defaultClass:'tfghjgkf'},left:{conditions:{mobile:'tfghjgki',tablet:'tfghjgkj',desktop:'tfghjgkk'},defaultClass:'tfghjgki'},right:{conditions:{mobile:'tfghjgkl',tablet:'tfghjgkm',desktop:'tfghjgkn'},defaultClass:'tfghjgkl'},center:{conditions:{mobile:'tfghjgko',tablet:'tfghjgkp',desktop:'tfghjgkq'},defaultClass:'tfghjgko'}}},textTransform:{values:{capitalize:{conditions:{mobile:'tfghjgkr',tablet:'tfghjgks',desktop:'tfghjgkt'},defaultClass:'tfghjgkr'},lowercase:{conditions:{mobile:'tfghjgku',tablet:'tfghjgkv',desktop:'tfghjgkw'},defaultClass:'tfghjgku'},uppercase:{conditions:{mobile:'tfghjgkx',tablet:'tfghjgky',desktop:'tfghjgkz'},defaultClass:'tfghjgkx'}}},textOverflow:{values:{ellipsis:{conditions:{mobile:'tfghjgl0',tablet:'tfghjgl1',desktop:'tfghjgl2'},defaultClass:'tfghjgl0'}}},width:{values:{'100vw':{conditions:{mobile:'tfghjgl3',tablet:'tfghjgl4',desktop:'tfghjgl5'},defaultClass:'tfghjgl3'},'100%':{conditions:{mobile:'tfghjgl6',tablet:'tfghjgl7',desktop:'tfghjgl8'},defaultClass:'tfghjgl6'},'100px':{conditions:{mobile:'tfghjgl9',tablet:'tfghjgla',desktop:'tfghjglb'},defaultClass:'tfghjgl9'},'170px':{conditions:{mobile:'tfghjglc',tablet:'tfghjgld',desktop:'tfghjgle'},defaultClass:'tfghjglc'}}},maxWidth:{values:{'100%':{conditions:{mobile:'tfghjglf',tablet:'tfghjglg',desktop:'tfghjglh'},defaultClass:'tfghjglf'}}},objectFit:{values:{contain:{conditions:{mobile:'tfghjgli',tablet:'tfghjglj',desktop:'tfghjglk'},defaultClass:'tfghjgli'}}},whiteSpace:{values:{nowrap:{conditions:{mobile:'tfghjgll',tablet:'tfghjglm',desktop:'tfghjgln'},defaultClass:'tfghjgll'},'pre-wrap':{conditions:{mobile:'tfghjglo',tablet:'tfghjglp',desktop:'tfghjglq'},defaultClass:'tfghjglo'}}},fontFamily:{values:{'Bagoss Condensed':{conditions:{mobile:'tfghjglr',tablet:'tfghjgls',desktop:'tfghjglt'},defaultClass:'tfghjglr'}}},visibility:{values:{visible:{conditions:{mobile:'tfghjglu',tablet:'tfghjglv',desktop:'tfghjglw'},defaultClass:'tfghjglu'},hidden:{conditions:{mobile:'tfghjglx',tablet:'tfghjgly',desktop:'tfghjglz'},defaultClass:'tfghjglx'},inherit:{conditions:{mobile:'tfghjgm0',tablet:'tfghjgm1',desktop:'tfghjgm2'},defaultClass:'tfghjgm0'}}}}});
;// CONCATENATED MODULE: ./src/design-lib/components/Button/Button.tsx







var Button = function(_param) {
    var Icon = _param.Icon, ariaLabel = _param.ariaLabel, asLink = _param.asLink, center = _param.center, className = _param.className, _colorVariant = _param.colorVariant, colorVariant = _colorVariant === void 0 ? "dark" : _colorVariant, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, fullWidth = _param.fullWidth, iconRight = _param.iconRight, label = _param.label, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, minWidth = _param.minWidth, onClick = _param.onClick, _shapeVariant = _param.shapeVariant, shapeVariant = _shapeVariant === void 0 ? "default" : _shapeVariant, _sizeVariant = _param.sizeVariant, sizeVariant = _sizeVariant === void 0 ? "medium" : _sizeVariant, _styleVariant = _param.styleVariant, styleVariant = _styleVariant === void 0 ? "primary" : _styleVariant, _type = _param.type, type = _type === void 0 ? "button" : _type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "Icon",
        "ariaLabel",
        "asLink",
        "center",
        "className",
        "colorVariant",
        "disabled",
        "fullWidth",
        "iconRight",
        "label",
        "loading",
        "minWidth",
        "onClick",
        "shapeVariant",
        "sizeVariant",
        "styleVariant",
        "type"
    ]);
    var buttonContent = loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()(loadingAnimation)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                className: sprinkles({
                    flexShrink: 0
                }),
                width: 14
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: sprinkles({
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }),
                children: label
            })
        ]
    });
    if (asLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()(styles_css_button({
                color: colorVariant,
                size: sizeVariant,
                style: styleVariant
            }), iconRight && sprinkles({
                flexDirection: "row-reverse"
            }), disabled && sprinkles({
                cursor: "not-allowed"
            }), center && sprinkles({
                margin: "0 auto"
            }), className)
        }, props), {
            children: buttonContent
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-label": ariaLabel,
        className: classnames_default()(styles_css_button({
            color: colorVariant,
            shape: shapeVariant,
            size: sizeVariant,
            style: styleVariant
        }), iconRight && sprinkles({
            flexDirection: "row-reverse"
        }), disabled && sprinkles({
            cursor: "not-allowed"
        }), center && sprinkles({
            margin: "0 auto"
        }), fullWidth && sprinkles({
            width: "100%"
        }), className),
        disabled: disabled,
        style: minWidth ? {
            minWidth: minWidth
        } : {},
        type: type,
        onClick: onClick
    }, props), {
        children: buttonContent
    }));
};

;// CONCATENATED MODULE: ./src/design-lib/components/Button/index.tsx


// EXTERNAL MODULE: ./src/design-lib/components/Toast/ToastError/index.tsx
var ToastError = __webpack_require__(7929);
// EXTERNAL MODULE: ./src/design-lib/theme.ts
var theme = __webpack_require__(56161);
// EXTERNAL MODULE: ./src/i18n-routes.ts
var i18n_routes = __webpack_require__(31693);
// EXTERNAL MODULE: ./src/shared-styles/common-variables.tsx
var common_variables = __webpack_require__(38730);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/types/listing.ts
var listing = __webpack_require__(76362);
// EXTERNAL MODULE: ./src/utils/isStorageSupported.ts
var isStorageSupported = __webpack_require__(17668);
// EXTERNAL MODULE: ./src/utils/new-property.ts
var new_property = __webpack_require__(69854);
// EXTERNAL MODULE: ./src/components/InventoryBannerBig/index.ts + 4 modules
var InventoryBannerBig = __webpack_require__(93156);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(42493);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/shared-styles/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/shared-styles/styles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var _vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(2848);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/AlreadyBookedBanner/styles.css.ts



var priorityAlreadyBookedButton = 'tfghjgk3 tfghjggl tfghjgko _1b5wm207r tfghjg1u tfghjg9u tfghjg6 tfghjgac _1g8x49p1j _1g8x49p35';
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/AlreadyBookedBanner/AlreadyBookedBanner.tsx










var AlreadyBookedBanner = function(props) {
    var t = (0,useTranslation/* default */.Z)().t;
    var tenant = useCurrentTenant();
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(priorityAlreadyBookedButton, props.className),
        children: [
            tenant === constants/* TENANTS.casavo */.rk.casavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon/* default.Clock */.Z.Clock, {}),
            tenant === constants/* TENANTS.ucsc */.rk.ucsc && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "tick",
                height: 20,
                src: "".concat(imageBasePath, "/images/tenants/ucsc/single-tick.svg"),
                width: 20
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                noMargin: true,
                strong: true,
                size: "m",
                children: t("priority:PriorityDetail_FloatingBanner_Booked_CTA")
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(66840);
// EXTERNAL MODULE: ./node_modules/@typeform/embed-react/build/index.js
var build = __webpack_require__(95309);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/ModalTypeForm.tsx



var getTypeFormIdByLang = function(lang) {
    return ({
        en: "d3ZHi6Ob",
        es: "blcg12C6",
        fr: "HgaZDHpY",
        it: "H4Vy2yV2"
    })[lang];
};
var ModalTypeForm = function() {
    var lang = (0,useTranslation/* default */.Z)().lang;
    var formId = getTypeFormIdByLang(lang);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build.Widget, {
        inlineOnMobile: true,
        id: "https://pfa9yx1mzt9.typeform.com/to/".concat(formId),
        style: {
            height: "100%"
        }
    });
};

// EXTERNAL MODULE: src/containers/PriorityDetail/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/PriorityDetail/styles.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA5WT3W6jMBCF73mKuYkEVZw1pKgsuelj7N3KtQ1Y8Q+yTepqxbuv+EniJlHV3qHhfHNm7ONdSytXlBj+JQBvhB5bawbNEDXS2BpOxKYI/c3V0FX6mL9lh2RMdguzn5lG8oCYsJx6YXQN1MhBaWT5iVvHDwnAu2C+q6HEmwguZ7g3TixYIwJnh+/MUGWzzATkOsLM+51AxkO+LIsZy7itIe8DOCMFu2H22Wfru57zf8kbv+4B4C3RrjFW1cunJJ7/SVGJN7E9ieyRJUwMroaqD4dHQ12Lj1c/zlO0VjDkueonR7Qct6vB8p4Tn5LBG9QIvwUltCIhLSrchy0Ujc3iweg82Ne99lvIGxtT7BtUcUfx+BCWQ/zRzmPyqjgTBBy1nGsgmkGqhEZrsnJcPPchm112cZ4BFLGt0KspJZKmaVpgvAEEOcabDH5BkcEToOWGL2GdNFNhvLbcry0vpovi/gUILbwg8gYvV5wJ10vyUYM2mt9oXlZNlK2z6py+x82rFey4aLspoyVeMgZTDNCjMgmXco7xqbuqz+/19yoek/E/C9/CayYEAAA="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var CayYEAAA_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(72435);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/styles.css.ts



var borderLeft = 'gc8s25e';
var floatingCta = 'gc8s255 tfghjg4r tfghjg3l tfghjg5x _1b5wm20c tfghjgbr';
var modalTypeForm = 'gc8s258';
var priceAndCommercialAreaWrapper = 'gc8s253 _1b5wm202x _1b5wm201r tfghjg1u tfghjga6';
var priorityDetailGalleryHeader = 'tfghjggz tfghjghi tfghjgi5 tfghjgio tfghjggc';
var priorityDetailGalleryWrapper = 'gc8s250';
var priorityDetailPhotoCta = 'gc8s257 tfghjghi tfghjgio tfghjgk0 tfghjggi tfghjg1u tfghjga6 tfghjg6 tfghjg29 tfghjg5b _1b5wm2080 tfghjg8l tfghjg9l tfghjgch tfghjger tfghjgeb';
var priorityMainInfo = 'gc8s25a tfghjgju tfghjggc tfghjghi tfghjgio tfghjg1z tfghjg9f tfghjgl6';
var priorityMainInfoHeader = {casavo:'gc8s25c tfghjg1x tfghjggc tfghjgft',ucsc:'gc8s25d tfghjg1x tfghjggc tfghjgft'};
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/ButtonFeedback.tsx












var ButtonFeedback = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var t = (0,useTranslation/* default */.Z)().t;
    var openModal = (0,ModalContext/* useModal */.dd)().openModal;
    var handleFeedbackCta = function() {
        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "FloatingBanner_Dislike");
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* ModalBase */.e, {
            className: modalTypeForm,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTypeForm, {})
        }), {
            overlay: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, (0,_object_spread/* default */.Z)({
        Icon: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon/* default.ThumbDownAlt */.Z.ThumbDownAlt, {});
        },
        label: t("priority:PriorityDetail-FloatingBanner-DislikeCTA"),
        styleVariant: "tertiary",
        onClick: handleFeedbackCta
    }, props));
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(65594);
// EXTERNAL MODULE: ./src/utils/getTranslatedStateOfMaintenance.ts
var getTranslatedStateOfMaintenance = __webpack_require__(77784);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/data.ts




var mockedPhotos = [
    {
        isPrimary: false,
        order: 0,
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/3ce6144c-15bf-48d7-84c0-18814b6a206b.png"
    },
    {
        isPrimary: false,
        order: 1,
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/80ffdcb6-77ee-4823-abcb-cc0c3737e688.jpg"
    },
    {
        isPrimary: false,
        order: 2,
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/c06e512f-a4b7-48f0-a175-9e0beb43ea0e.png"
    },
    {
        isPrimary: false,
        order: 3,
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/df18382a-90d6-420c-9ed0-20fc2ad74f38.png"
    },
    {
        isPrimary: false,
        order: 4,
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/777ae9f0-3c71-47b7-aa9c-91f95d53139c.jpeg"
    },
    {
        isPrimary: false,
        order: 5,
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/pictures/6e9a5529-fa6d-4568-b842-ac1eecc354a4.png"
    }, 
];
var propertyMock = {
    askedPrice: {
        cents: 14000000,
        currency: "€"
    },
    city: "it/milano",
    detail: {
        titles: [
            {
                language: "it",
                text: "Bilocale di 40m\xb2 in Via Elia Lombardini 11"
            },
            {
                language: "en",
                text: "Studio of 40m\xb2 in Via Elia Lombardini 11"
            },
            {
                language: "fr",
                text: "Appartement 2 pi\xe8ces de 40m\xb2 - 20143"
            }, 
        ]
    },
    id: "9f09c3a5-de86-46bc-bc7b-7ffa3b585d05",
    photos: mockedPhotos,
    planimetries: {
        url: "https://casavo-nika-media-staging.imgix.net/listing/1174/floorplans/5d132041-4cc2-4cae-b1ef-f751dec27544.png"
    },
    title: "Bilocale di 40m\xb2 in Via Elia Lombardini 11",
    zone: "Navigli"
};
var iconUrl = function(iconName, tenant) {
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    switch(tenant){
        case constants/* TENANTS.casavo */.rk.casavo:
            return "".concat(imageBasePath, "/images/advantages/").concat(iconName, ".svg");
        case constants/* TENANTS.ucsc */.rk.ucsc:
            return "".concat(imageBasePath, "/images/tenants/ucsc/advantages/").concat(iconName, ".svg");
    }
};
var _obj;
var iconSize = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* TENANTS.casavo */.rk.casavo, 80), (0,_define_property/* default */.Z)(_obj, constants/* TENANTS.ucsc */.rk.ucsc, 48), _obj);
var advantagesCTA = function(tenant) {
    return [
        {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Advance_Description",
            iconUrl: iconUrl("success-small", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_FloatingBanner_Bullet1"
        },
        {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Waitlist_Description",
            iconUrl: iconUrl("appointment", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Waitlist_Title"
        },
        {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_RightPrice_Description",
            iconUrl: iconUrl("blocked-price", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_FloatingBanner_Bullet3"
        }, 
    ];
};
var advantages = function(tenant) {
    var adv = [
        tenant === constants/* TENANTS.casavo */.rk.casavo ? {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Advance_Description",
            iconUrl: iconUrl("success-small", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Advance_Title"
        } : {
            descriptionTranslationKey: "unicredit:Priority_DetailPage_AdvantagesCard_Advance_Description",
            iconUrl: iconUrl("success-small", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "unicredit:Priority_DetailPage_AdvantagesCard_Advance_Title"
        },
        {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Waitlist_Description",
            iconUrl: iconUrl("appointment", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Waitlist_Title"
        },
        tenant === constants/* TENANTS.casavo */.rk.casavo ? {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_RightPrice_Description",
            iconUrl: iconUrl("blocked-price", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_FloatingBanner_Bullet3"
        } : undefined,
        {
            descriptionTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Support_Description",
            iconUrl: iconUrl("handshake", tenant),
            imageSize: iconSize[tenant],
            titleTranslationKey: "priority:Priority_DetailPage_AdvantagesCard_Support_Title"
        }, 
    ];
    return adv.filter(Boolean);
};
var getCharacteristics = function(priority, t) {
    var ref;
    return [
        {
            amount: priority.bathrooms,
            icon: "bathroom",
            title: "bathrooms",
            value: priority.bathrooms
        },
        {
            amount: priority.balconies,
            icon: "balcony",
            title: "balconies",
            value: priority.balconies
        },
        {
            amount: (0,getTranslatedStateOfMaintenance/* getTranslatedStateOfMaintenance */.o)((ref = priority.stateOfMaintenance) === null || ref === void 0 ? void 0 : ref.toLowerCase(), t),
            icon: null,
            title: "status",
            value: priority.stateOfMaintenance
        }, 
    ];
};
var getRooms = function(rooms) {
    return {
        amount: rooms,
        icon: "rooms",
        title: "rooms",
        value: rooms
    };
};

// EXTERNAL MODULE: ./src/components/Floor/index.ts + 1 modules
var Floor = __webpack_require__(37826);
// EXTERNAL MODULE: ./src/containers/ListingDetail/Characteristics.tsx
var Characteristics = __webpack_require__(9577);
// EXTERNAL MODULE: ./src/containers/ListingDetail/styles.css.ts
var ListingDetail_styles_css = __webpack_require__(37389);
// EXTERNAL MODULE: ./src/context/Cities.tsx
var Cities = __webpack_require__(54673);
// EXTERNAL MODULE: ./src/utils/format-listing-pricePerSquareMeter.ts
var format_listing_pricePerSquareMeter = __webpack_require__(47593);
// EXTERNAL MODULE: ./src/utils/format-listing-sellingPrice.ts
var format_listing_sellingPrice = __webpack_require__(65565);
// EXTERNAL MODULE: ./src/utils/utils-potential-properties.ts
var utils_potential_properties = __webpack_require__(43799);
// EXTERNAL MODULE: ./src/components/Icon/Chevron/index.tsx + 1 modules
var Chevron = __webpack_require__(71169);
// EXTERNAL MODULE: ./src/components/InventoryBannerBig/ThisIsACasavoClaim.tsx
var ThisIsACasavoClaim = __webpack_require__(91686);
// EXTERNAL MODULE: src/components/InventoryBannerSmall/styles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/InventoryBannerSmall/styles.css.ts.vanilla.css","source":"Ll8xMHh3ZXVxMSB7CiAgcGFkZGluZzogdmFyKC0tXzFtdWg4bmsyOCk7Cn0KLl8xMHh3ZXVxMiB7CiAgZmxleC1zaHJpbms6IDA7CiAgaGVpZ2h0OiA4cHg7CiAgbWFyZ2luLWxlZnQ6IHZhcigtLV8xbXVoOG5rMmEpOwogIHRyYW5zZm9ybTogcm90YXRlKDI3MGRlZyk7CiAgd2lkdGg6IDhweDsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fMTB4d2V1cTEgewogICAgbWFyZ2luLWxlZnQ6IDA7CiAgICBtYXJnaW4tcmlnaHQ6IDA7CiAgICBib3JkZXItcmFkaXVzOiA4cHg7CiAgfQp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var styles_css_ts_vanilla_css_source_Ll8xMHh3ZXVxMSB7CiAgcGFkZGluZzogdmFyKC0tXzFtdWg4bmsyOCk7Cn0KLl8xMHh3ZXVxMiB7CiAgZmxleC1zaHJpbms6IDA7CiAgaGVpZ2h0OiA4cHg7CiAgbWFyZ2luLWxlZnQ6IHZhcigtLV8xbXVoOG5rMmEpOwogIHRyYW5zZm9ybTogcm90YXRlKDI3MGRlZyk7CiAgd2lkdGg6IDhweDsKfQpAbWVkaWEgc2NyZWVuIGFuZCAobWluLXdpZHRoOiA3NjhweCkgewogIC5fMTB4d2V1cTEgewogICAgbWFyZ2luLWxlZnQ6IDA7CiAgICBtYXJnaW4tcmlnaHQ6IDA7CiAgICBib3JkZXItcmFkaXVzOiA4cHg7CiAgfQp9_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(53049);
;// CONCATENATED MODULE: ./src/components/InventoryBannerSmall/styles.css.ts



var bannerContainer = '_10xweuq1 tfghjg6 tfghjg2c tfghjgki tfghjgbi';
var chevron = '_10xweuq2';
;// CONCATENATED MODULE: ./src/components/InventoryBannerSmall/InventoryBannerSmall.tsx













var InventoryBannerSmall = function(param) {
    var _color = param.color, color = _color === void 0 ? "offWhite" : _color, i18nKeyLabel = param.i18nKeyLabel, inventory = param.inventory, onClick = param.onClick, _tenant = param.tenant, tenant = _tenant === void 0 ? constants/* TENANTS.casavo */.rk.casavo : _tenant;
    var device = (0,Device/* useDevice */.Fy)();
    var isMobile = device === "mobile";
    var isOdaInventory = inventory === listing/* CasavoInventory.Agency */.M.Agency;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(bannerContainer, styles_css/* backgroundColor */.Cz[color]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
                alignItems: "center",
                display: "flex"
            }), isOdaInventory && (0,sprinkles_css/* sprinkles */.K)({
                marginBottom: "l"
            })),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Claim, {
                    i18nKey: i18nKeyLabel,
                    tenant: tenant
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        marginLeft: "auto",
                        textDecoration: "underline"
                    }),
                    "data-testid": "casavo-banner-cta",
                    onClick: onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                        noMargin: true,
                        size: "s",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                            i18Key: isMobile ? "PropertyAdvantages:PropertyAdvantages_Card_CTA" : "PropertyAdvantages:PropertyAdvantages_CasavoGuarantee_Banner_CTA"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron/* default */.Z, {
                    className: chevron
                })
            ]
        })
    });
};
var Claim = function(param) {
    var i18nKey = param.i18nKey, tenant = param.tenant;
    switch(tenant){
        case constants/* TENANTS.casavo */.rk.casavo:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThisIsACasavoClaim/* ThisIsACasavoClaim */.l, {
                i18nKey: i18nKey
            });
        case constants/* TENANTS.ucsc */.rk.ucsc:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UCSCClaim, {
                i18nKey: i18nKey
            });
    }
};
var UCSCClaim = function(param) {
    var i18nKey = param.i18nKey;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(styles_css/* flexCenter */._7, styles_css/* gap.s */.SG.s),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
            noMargin: true,
            size: "m",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                i18Key: i18nKey
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/InventoryBannerSmall/index.ts


// EXTERNAL MODULE: ./src/components/LabelWithCheck/index.ts + 1 modules
var LabelWithCheck = __webpack_require__(53891);
// EXTERNAL MODULE: ./src/containers/PriorityDetail/useVisitInterestBeforeLogin.ts
var useVisitInterestBeforeLogin = __webpack_require__(28359);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/RequestVisit/RequestVisitCTA.tsx

















var RequestVisitCTA = function(_param) {
    var gtmTouchPoint = _param.gtmTouchPoint, handleCtaClick = _param.handleCtaClick, hasFullLabelOnMobile = _param.hasFullLabelOnMobile, _isFullWidth = _param.isFullWidth, isFullWidth = _isFullWidth === void 0 ? true : _isFullWidth, setShowToastError = _param.setShowToastError, thankYouPageUrl = _param.thankYouPageUrl, transactionId = _param.transactionId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "gtmTouchPoint",
        "handleCtaClick",
        "hasFullLabelOnMobile",
        "isFullWidth",
        "setShowToastError",
        "thankYouPageUrl",
        "transactionId"
    ]);
    var ref = (0,AuthProvider/* useAuthentication */.JL)(), isLoading = ref.isLoading, user = ref.user;
    var t = (0,useTranslation/* default */.Z)().t;
    var device = (0,Device/* useDevice */.Fy)();
    var ctaLabel = device === "desktop" || hasFullLabelOnMobile ? t("priority:Priority_DetailPage_FloatingBanner_CTA") : t("priority:Priority_DetailPage_FloatingBanner_CTAmobile");
    var openModal = (0,ModalContext/* useModal */.dd)().openModal;
    var ref1 = (0,BottomSheetContext/* useBottomSheet */.a)(), closeBottomSheet = ref1.closeBottomSheet, openBottomSheet = ref1.openBottomSheet;
    var ref2 = (0,useVisitInterestBeforeLogin/* useVisitInterestBeforeLogin */.s)(), resetVisitInterestBeforeLogin = ref2.resetVisitInterestBeforeLogin, setVisitInterestBeforeLoginToTrue = ref2.setVisitInterestBeforeLoginToTrue, visitInterestBeforeLogin = ref2.visitInterestBeforeLogin;
    var expressVisit = useExpressPotentialPropertyVisitInterest(transactionId);
    var openVisitRequestModal = function() {
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(VisitRequestModal, {
            expressVisitInterest: function(args) {
                return expressVisit({
                    args: args,
                    tenant: constants/* TENANTS.casavo */.rk.casavo
                });
            },
            setShowToastError: setShowToastError,
            thankYouPageUrl: thankYouPageUrl
        }), {
            overlay: true
        });
    };
    (0,react.useEffect)(function() {
        if (user && !isLoading && visitInterestBeforeLogin !== null) {
            resetVisitInterestBeforeLogin();
            device === "mobile" && closeBottomSheet();
            openVisitRequestModal();
        }
    }, [
        user,
        isLoading,
        visitInterestBeforeLogin
    ]);
    var handleVisitInterestClick = function() {
        handleCtaClick();
        if (!(user === null || user === void 0 ? void 0 : user.id) && !isLoading) {
            setVisitInterestBeforeLoginToTrue();
            if (device === "mobile") {
                openBottomSheet(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserAuthentication/* UserAuthentication */.z, {
                    conceptImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                        height: 75,
                        name: "write",
                        width: 75
                    }),
                    mainTitle: "Login_PriorityDetail_BottomSheet_Title",
                    returnUrl: window.location.href,
                    touchPoint: gtmTouchPoint
                }), {
                    bgColor: "offWhite",
                    isPriority: true,
                    minHeight: 610
                });
            } else {
                openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModalForm/* default */.Z, {
                    isPriority: true,
                    bgColor: "offWhite",
                    conceptImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                        height: 120,
                        name: "write",
                        width: 120
                    }),
                    mainTitle: "Login_PriorityDetail_BottomSheet_Title",
                    returnURL: window.location.href,
                    touchPoint: gtmTouchPoint
                }), LoginModalForm/* loginModalFormOptions */.S);
            }
        } else {
            openVisitRequestModal();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, (0,_object_spread/* default */.Z)({
        "data-testid": gtmTouchPoint,
        fullWidth: isFullWidth,
        label: ctaLabel,
        minWidth: 200,
        onClick: handleVisitInterestClick
    }, props));
};

;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/RequestVisit/index.ts


;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/PriorityDetailInfo/FloatingBanner.tsx



















var FloatingBanner = function(param) {
    var advantages = param.advantages, disableVisitCTA = param.disableVisitCTA, handleRequestVisitCtaBuyerInfo = param.handleRequestVisitCtaBuyerInfo, hasBuyerInfo = param.hasBuyerInfo, setShowToastError = param.setShowToastError, showAlreadyBookedBanner = param.showAlreadyBookedBanner, thankYouPageUrl = param.thankYouPageUrl, transactionId = param.transactionId;
    var t = (0,useTranslation/* default */.Z)().t;
    var tenant = useCurrentTenant();
    var ref = (0,AuthProvider/* useAuthentication */.JL)(), isLoading = ref.isLoading, user = ref.user;
    var handleClickRequestVisitCta = function() {
        return user && !isLoading ? (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "FloatingBanner_RequestVisit") : (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "RequestVisit");
    };
    var RequestVisitCta = hasBuyerInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
        fullWidth: true,
        disabled: disableVisitCTA,
        label: t("priority:Priority_DetailPage_FloatingBanner_CTA"),
        loading: user && disableVisitCTA,
        minWidth: 200,
        styleVariant: "primary",
        onClick: handleRequestVisitCtaBuyerInfo
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestVisitCTA, {
        gtmTouchPoint: "FromVisitLockedPriority",
        handleCtaClick: handleClickRequestVisitCta,
        setShowToastError: setShowToastError,
        thankYouPageUrl: thankYouPageUrl,
        transactionId: transactionId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ListingDetail_styles_css/* detailContactBox */.QS,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityCardBadge/* PriorityBadge */.U, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.H4, {
                children: t("priority:Priority_DetailPage_FloatingBanner_Title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: styles_css/* paddingBottom.l */.Et.l,
                children: [
                    tenant === constants/* TENANTS.casavo */.rk.casavo && advantages.map(function(advantage) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelWithCheck/* LabelWithCheck */.y, {
                            tenant: tenant,
                            children: t(advantage.titleTranslationKey)
                        }, advantage.titleTranslationKey);
                    }),
                    tenant === constants/* TENANTS.ucsc */.rk.ucsc && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                        size: "s",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                            i18Key: "unicredit:Priority_DetailPage_FloatingBanner_Desciption"
                        })
                    })
                ]
            }),
            showAlreadyBookedBanner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlreadyBookedBanner, {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "m"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    RequestVisitCta,
                    tenant === constants/* TENANTS.casavo */.rk.casavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFeedback, {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "xl",
                            marginTop: "m"
                        })
                    })
                ]
            }),
            tenant === constants/* TENANTS.casavo */.rk.casavo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                    color: "root.neutral.400",
                    size: "xs",
                    children: showAlreadyBookedBanner ? t("priority:PriorityDetail_FloatingBanner_Booked_Description") : t("priority:PriorityDetail-FloatingBanner-FeedbackDescription")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/design-lib/style-theme/theme.css.ts
var theme_css = __webpack_require__(81498);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/PriorityDetailInfo/ModalPrice/ModalPrice.tsx


















var ModalPrice_obj;
var tenantTitleTypography = (ModalPrice_obj = {}, (0,_define_property/* default */.Z)(ModalPrice_obj, constants/* TENANTS.casavo */.rk.casavo, dist.H2), (0,_define_property/* default */.Z)(ModalPrice_obj, constants/* TENANTS.ucsc */.rk.ucsc, dist.H3), ModalPrice_obj);
var ModalPrice = function(param) {
    var disableVisitCta = param.disableVisitCta, handleRequestVisitCtaBuyerInfo = param.handleRequestVisitCtaBuyerInfo, hasBuyerInfo = param.hasBuyerInfo, isSuccess = param.isSuccess, price = param.price, setShowToastError = param.setShowToastError, showAlreadyBookedBanner = param.showAlreadyBookedBanner, thankYouPageUrl = param.thankYouPageUrl, transactionId = param.transactionId;
    var tenant = useCurrentTenant();
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var user = (0,AuthProvider/* useAuthentication */.JL)().user;
    var TitleTypography = tenantTitleTypography[tenant];
    var title = isSuccess ? t("priority:PriceAnalysis_GoodPrice_Modal_Title") : t("priority:PriceAnalysis_HighPrice_Modal_Title");
    var body = isSuccess ? "priority:PriceAnalysis_GoodPrice_Modal_Body" : "priority:PriceAnalysis_HighPrice_Modal_Body";
    var imageName = isSuccess ? "ideas" : "salary";
    var fsProperty = isSuccess ? "GoodPrice" : "HighPrice";
    var requestVisitCtaHandleClick = function() {
        return (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "PriceAnalysis_ModalCTA", fsProperty);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "2xl"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "m",
                            textAlign: "center"
                        }),
                        children: [
                            tenant === constants/* TENANTS.casavo */.rk.casavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                                height: 106,
                                name: imageName,
                                width: 106
                            }),
                            tenant === constants/* TENANTS.ucsc */.rk.ucsc && /*#__PURE__*/ (0,jsx_runtime.jsx)(UCSCAmount, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                        size: "m",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                            i18Key: body,
                            values: {
                                AskingPrice: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(false, price.askedPrice, t, lang),
                                Discount: price.discountedPrice,
                                SuggestedPrice: price.estimatedListingPrice
                            }
                        })
                    })
                ]
            }),
            !showAlreadyBookedBanner && (hasBuyerInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                fullWidth: true,
                "data-testid": "FromPriceAnalysis",
                disabled: disableVisitCta,
                label: t("priority:Priority_DetailPage_FloatingBanner_CTA"),
                loading: user && disableVisitCta,
                minWidth: 200,
                styleVariant: "primary",
                onClick: handleRequestVisitCtaBuyerInfo
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestVisitCTA, {
                hasFullLabelOnMobile: true,
                className: (0,sprinkles_css/* sprinkles */.K)({
                    margin: "0 auto"
                }),
                gtmTouchPoint: "FromPriceAnalysis",
                handleCtaClick: requestVisitCtaHandleClick,
                isFullWidth: false,
                setShowToastError: setShowToastError,
                thankYouPageUrl: thankYouPageUrl,
                transactionId: transactionId
            }))
        ]
    });
};
var UCSCAmount = function() {
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        alt: "amount",
        height: 48,
        src: "".concat(imageBasePath, "/images/tenants/ucsc/amount.svg"),
        width: 48
    });
};

// EXTERNAL MODULE: src/containers/PriorityDetail/sections/PriorityDetailInfo/ModalPrice/ModalPrice.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/containers/PriorityDetail/sections/PriorityDetailInfo/ModalPrice/ModalPrice.css.ts.vanilla.css","source":"QG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTAyNHB4KSB7CiAgLl8xZWkwcWE1MCB7CiAgICBtYXgtd2lkdGg6IDU5MHB4OwogIH0KfQ=="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var ModalPrice_css_ts_vanilla_css_source_QG1lZGlhIHNjcmVlbiBhbmQgKG1pbi13aWR0aDogMTAyNHB4KSB7CiAgLl8xZWkwcWE1MCB7CiAgICBtYXgtd2lkdGg6IDU5MHB4OwogIH0KfQ_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(91238);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/PriorityDetailInfo/ModalPrice/ModalPrice.css.ts

var modalPriceWidth = '_1ei0qa50';
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/PriorityDetailInfo/PriceBadge.tsx







var PriceBadge = function(param) {
    var isSuccess = param.isSuccess;
    var t = (0,useTranslation/* default */.Z)().t;
    var iconStyle = (0,sprinkles_css/* sprinkles */.K)({
        marginBottom: "xs",
        marginX: "auto"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            alignSelf: "center",
            textAlign: "center"
        }),
        children: isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon/* default.Verified */.Z.Verified, {
                    className: classnames_default()(iconStyle, styles_css/* color.success500 */.$_.success500)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                    children: t("priority:PriceAnalysis_GoodPrice_Tag")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon/* default.Info */.Z.Info, {
                    className: classnames_default()(iconStyle, styles_css/* color.greyscale500 */.$_.greyscale500)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                    children: t("priority:PriceAnalysis_HighPrice_Tag")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/PriorityDetailInfo/PriorityPriceInfo/PriorityPriceInfo.tsx






















var PriorityPriceInfo = function(param) {
    var disableVisitCta = param.disableVisitCta, handleRequestVisitCtaBuyerInfo = param.handleRequestVisitCtaBuyerInfo, hasBuyerInfo = param.hasBuyerInfo, price = param.price, priority = param.priority, setShowToastError = param.setShowToastError, showAlreadyBookedBanner = param.showAlreadyBookedBanner, thankYouPageUrl = param.thankYouPageUrl;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var tenant = useCurrentTenant();
    var buildingFloors = priority.buildingFloors, commercialArea = priority.commercialArea, entranceFloor = priority.entranceFloor, transactionId = priority.transactionId;
    var askedPrice = price.askedPrice, estimatedListingPrice = price.estimatedListingPrice;
    var ref1 = (0,utils_potential_properties/* getPriceStatus */.O)(askedPrice.cents, estimatedListingPrice.cents), isGoodPrice = ref1.isGoodPrice, roundedDiscountedPrice = ref1.roundedDiscountedPrice;
    var fsProperty = isGoodPrice ? "GoodPrice" : "HighPrice";
    var description = isGoodPrice ? "priority:PriceAnalysis_GoodPrice_Description" : "priority:PriceAnalysis_HighPrice_Description";
    var openModal = (0,ModalContext/* useModal */.dd)().openModal;
    var handleCtaClick = function() {
        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "PriceAnalysisCTA", fsProperty);
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBase/* ModalBase */.e, {
            className: modalPriceWidth,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPrice, {
                disableVisitCta: disableVisitCta,
                handleRequestVisitCtaBuyerInfo: handleRequestVisitCtaBuyerInfo,
                hasBuyerInfo: hasBuyerInfo,
                isSuccess: isGoodPrice,
                price: {
                    askedPrice: askedPrice,
                    discountedPrice: roundedDiscountedPrice,
                    estimatedListingPrice: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(false, estimatedListingPrice, t, lang)
                },
                setShowToastError: setShowToastError,
                showAlreadyBookedBanner: showAlreadyBookedBanner,
                thankYouPageUrl: thankYouPageUrl,
                transactionId: transactionId
            })
        }), {
            background: theme_css/* theme.colors.brandedModalBackground */.r.colors.brandedModalBackground,
            borderRadius: theme_css/* theme.border.brandedModalBorderRadius */.r.border.brandedModalBorderRadius,
            overlay: true
        });
    };
    (0,react.useEffect)(function() {
        (0,eventsHandlers/* handleShow */.Hf)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "PriceAnalysisBanner", fsProperty);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceInfoContainer, {
        handleClick: tenant !== "ucsc" ? handleCtaClick : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: priorityMainInfoHeader[tenant],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            Boolean(commercialArea) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* BodyM */.iO, {
                                strong: true,
                                alignment: "center",
                                as: "p",
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    paddingBottom: {
                                        mobile: "xs"
                                    }
                                }),
                                children: [
                                    commercialArea,
                                    " m\xb2"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Small */.x4, {
                                alignment: "center",
                                color: "greyscale500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Floor/* Floor */.O, {
                                    buildingFloors: buildingFloors,
                                    entireBuilding: false,
                                    entranceFloor: entranceFloor,
                                    floorPosition: []
                                })
                            })
                        ]
                    }),
                    askedPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(borderLeft, (0,sprinkles_css/* sprinkles */.K)({
                            alignSelf: "center"
                        })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                strong: true,
                                alignment: "center",
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    paddingBottom: {
                                        mobile: "xs"
                                    }
                                }),
                                children: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(false, askedPrice, t, lang)
                            }),
                            Boolean(commercialArea) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                                alignment: "center",
                                color: "greyscale500",
                                children: (0,format_listing_pricePerSquareMeter/* formatListingPricePerSquareMeter */.A)(askedPrice, commercialArea, lang)
                            })
                        ]
                    }),
                    tenant === constants/* TENANTS.casavo */.rk.casavo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(borderLeft),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceBadge, {
                            isSuccess: isGoodPrice
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignSelf: "center",
                    textAlign: "left"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                    components: {
                        u: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                textDecoration: "underline"
                            })
                        })
                    },
                    i18Key: tenant === constants/* TENANTS.ucsc */.rk.ucsc ? "unicredit:PriceAnalysis_Description" : description
                })
            })
        ]
    });
};
var PriceInfoContainer = function(param) {
    var children = param.children, handleClick = param.handleClick;
    if (handleClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: priorityMainInfo,
            onClick: handleClick,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: priorityMainInfo,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/PriorityDetailInfo/PriorityDetailInfo.tsx

























function getInventoryBannerKey(tenant, isPriorityLocked) {
    switch(tenant){
        case constants/* TENANTS.ucsc */.rk.ucsc:
            return "unicredit:PriorityDetail_TeasingBanner_Description_v2";
        case constants/* TENANTS.casavo */.rk.casavo:
            return isPriorityLocked ? "priority:PriorityDetail_TeasingBanner_NotLogged_Description" : "priority:Priority_DetailPage_Banner_Description";
    }
}
var PriorityDetailInfo_obj;
var titleTenantTypography = (PriorityDetailInfo_obj = {}, (0,_define_property/* default */.Z)(PriorityDetailInfo_obj, constants/* TENANTS.casavo */.rk.casavo, index_es/* Heading2 */.XJ), (0,_define_property/* default */.Z)(PriorityDetailInfo_obj, constants/* TENANTS.ucsc */.rk.ucsc, index_es/* Heading3 */.aC), PriorityDetailInfo_obj);
var PriorityDetailInfo = function(param) {
    var advantages = param.advantages, disableVisitCTA = param.disableVisitCTA, handleBannerCtaClick = param.handleBannerCtaClick, handleRequestVisitCtaBuyerInfo = param.handleRequestVisitCtaBuyerInfo, hasBuyerInfo = param.hasBuyerInfo, isPriorityLocked = param.isPriorityLocked, priority = param.priority, setShowToastError = param.setShowToastError, showAlreadyBookedBanner = param.showAlreadyBookedBanner, thankYouPageUrl = param.thankYouPageUrl;
    var ref;
    var device = (0,Device/* useDevice */.Fy)();
    var cities = (0,Cities/* useCities */.M1)();
    var ref1 = (0,useTranslation/* default */.Z)(), lang = ref1.lang, t = ref1.t;
    var tenant = useCurrentTenant();
    var askedPrice = priority.askedPrice, buildingFloors = priority.buildingFloors, commercialArea = priority.commercialArea, entranceFloor = priority.entranceFloor, estimatedListingPrice = priority.estimatedListingPrice, transactionId = priority.transactionId;
    var roundedAskedPrice = (0,utils_potential_properties/* roundPrice */._)(priority.askedPrice || priority.valuation);
    var roundedEstimatedListingPrice = estimatedListingPrice && (0,utils_potential_properties/* roundPrice */._)(estimatedListingPrice);
    var showPriceInfo = priority.status === "priority" && estimatedListingPrice;
    var TitleTypography = titleTenantTypography[tenant];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ListingDetail_styles_css/* responsiveContainerDetail */.aE,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InventoryBannerSmall, {
                                color: "brandedBackground",
                                i18nKeyLabel: getInventoryBannerKey(tenant, isPriorityLocked),
                                inventory: listing/* CasavoInventory.Priority */.M.Priority,
                                tenant: tenant,
                                onClick: handleBannerCtaClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignItems: {
                                        desktop: "center"
                                    },
                                    display: {
                                        desktop: "flex"
                                    },
                                    paddingBottom: {
                                        mobile: "m"
                                    }
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingBottom: {
                                                desktop: 0,
                                                mobile: "s"
                                            },
                                            textTransform: "uppercase"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                            noMargin: true,
                                            color: "root.neutral.600",
                                            size: "s",
                                            children: (ref = cities.list.find(function(city) {
                                                return city.slug === priority.city;
                                            })) === null || ref === void 0 ? void 0 : ref.translatedCityName
                                        })
                                    }),
                                    (priority === null || priority === void 0 ? void 0 : priority.zone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            device === "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: styles_css/* pointShapeDivider */.wx
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                                noMargin: true,
                                                color: "root.neutral.500",
                                                size: "s",
                                                children: priority === null || priority === void 0 ? void 0 : priority.zone.label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                as: "h1",
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    marginBottom: "l"
                                }),
                                children: priority.title
                            })
                        ]
                    }),
                    showPriceInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityPriceInfo, {
                        disableVisitCta: disableVisitCTA,
                        handleRequestVisitCtaBuyerInfo: handleRequestVisitCtaBuyerInfo,
                        hasBuyerInfo: hasBuyerInfo,
                        price: {
                            askedPrice: roundedAskedPrice,
                            estimatedListingPrice: roundedEstimatedListingPrice
                        },
                        priority: {
                            buildingFloors: buildingFloors,
                            commercialArea: commercialArea,
                            entranceFloor: entranceFloor,
                            transactionId: transactionId
                        },
                        setShowToastError: setShowToastError,
                        showAlreadyBookedBanner: showAlreadyBookedBanner,
                        thankYouPageUrl: thankYouPageUrl
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: priceAndCommercialAreaWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()(styles_css/* flexBetween */.h8, (0,sprinkles_css/* sprinkles */.K)({
                                    columnGap: "m"
                                })),
                                children: [
                                    Boolean(priority.commercialArea) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.H4, {
                                        noMargin: true,
                                        children: [
                                            priority.commercialArea,
                                            " m\xb2"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.H4, {
                                        noMargin: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Floor/* Floor */.O, {
                                            buildingFloors: priority.buildingFloors,
                                            entireBuilding: false,
                                            entranceFloor: priority.entranceFloor,
                                            floorPosition: []
                                        })
                                    })
                                ]
                            }),
                            askedPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    alignSelf: {
                                        mobile: "flex-start"
                                    },
                                    textAlign: "right"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingBottom: {
                                                mobile: "xs"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.H3, {
                                            noMargin: true,
                                            children: (0,format_listing_sellingPrice/* formatListingSellingPrice */.F)(false, roundedAskedPrice, t, lang)
                                        })
                                    }),
                                    Boolean(priority.commercialArea) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                        noMargin: true,
                                        color: "root.neutral.500",
                                        size: "xs",
                                        children: (0,format_listing_pricePerSquareMeter/* formatListingPricePerSquareMeter */.A)(askedPrice, commercialArea, lang)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Characteristics/* default */.Z, {
                        characteristics: getCharacteristics(priority, t),
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginTop: "xl"
                        }),
                        rooms: getRooms(priority.rooms)
                    })
                ]
            }),
            device === "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingBanner, {
                    advantages: advantages,
                    disableVisitCTA: disableVisitCTA,
                    handleRequestVisitCtaBuyerInfo: handleRequestVisitCtaBuyerInfo,
                    hasBuyerInfo: hasBuyerInfo,
                    setShowToastError: setShowToastError,
                    showAlreadyBookedBanner: showAlreadyBookedBanner,
                    thankYouPageUrl: thankYouPageUrl,
                    transactionId: priority.transactionId
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SimilarPropertiesCarousel/index.tsx
var SimilarPropertiesCarousel = __webpack_require__(11244);
// EXTERNAL MODULE: ./src/design-lib/components/Divider/index.tsx + 1 modules
var Divider = __webpack_require__(84494);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/sections/SimilarProperties.tsx






var SimilarPropertiesSection = function(param) {
    var similarListings = param.similarListings, similarPriorities = param.similarPriorities;
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                alignment: "center",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    paddingY: "m"
                }),
                children: t("priority:Priority_DetailPage_SimilarProperties_Title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                alignment: "center",
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginBottom: "2xl"
                }),
                children: t("priority:Priority_DetailPage_SimilarProperties_Description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarPropertiesCarousel/* SimilarPropertiesCarousel */.E, {
                similarListings: similarListings,
                similarPriorities: similarPriorities
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/containers/PriorityDetail/utils.ts
var utils = __webpack_require__(15099);
;// CONCATENATED MODULE: ./src/containers/PriorityDetail/PriorityDetail.tsx





















































var PriorityDetail = function(param) {
    var buyerInfo = param.buyerInfo, cities = param.cities, priority = param.priority, similarListings = param.similarListings, similarPriorities = param.similarPriorities;
    var expressVisit = useExpressPotentialPropertyVisitInterest(priority.transactionId);
    var device = (0,Device/* useDevice */.Fy)();
    var tenant = useCurrentTenant();
    var ref = (0,AuthProvider/* useAuthentication */.JL)(), isLoading = ref.isLoading, user = ref.user;
    var ref1 = (0,BottomSheetContext/* useBottomSheet */.a)(), closeBottomSheet = ref1.closeBottomSheet, openBottomSheet = ref1.openBottomSheet;
    var ref2 = (0,ModalContext/* useModal */.dd)(), closeModal = ref2.closeModal, openModal = ref2.openModal;
    var ref3 = (0,react.useState)(false), isSubmitting = ref3[0], setSubmitting = ref3[1];
    var ref4 = (0,react.useState)(false), showToastError = ref4[0], setShowToastError = ref4[1];
    var ref5 = (0,react.useState)(undefined), visitInterest = ref5[0], setVisitInterest = ref5[1];
    var t = (0,useTranslation/* default */.Z)().t;
    var casavoInventoryBannerBigRef = (0,react.useRef)(null);
    var ref6 = (0,utils/* parsePotentialPropertyMedia */.qX)(priority.potentialPropertyMedia), floorPlan = ref6.floorPlan, photoGallery = ref6.photoGallery;
    var planimetry = floorPlan.length > 0 ? floorPlan[0].url : "";
    var thankYouPageUrl = (0,i18n_routes/* getPriorityThankyouPage */.sA)(priority.slug, priority.city);
    var isPriorityLocked = !buyerInfo && !user && !isLoading;
    var resetVisitInterestBeforeLogin = (0,useVisitInterestBeforeLogin/* useVisitInterestBeforeLogin */.s)().resetVisitInterestBeforeLogin;
    var showAlreadyBookedBanner = visitInterest === api_gluglu_auth/* GetPotentialPropertyVisitInterestResponse.INTEREST_ALREADY_EXPRESSED */.Mc.INTEREST_ALREADY_EXPRESSED;
    var similarProperties = (0,_to_consumable_array/* default */.Z)(similarPriorities).concat((0,_to_consumable_array/* default */.Z)(similarListings));
    var requestVisitCtaLabel = device === "mobile" ? t("priority:Priority_DetailPage_FloatingBanner_CTAmobile") : t("priority:Priority_DetailPage_FloatingBanner_CTA");
    var ref7 = (0,react.useMemo)(function() {
        return [
            advantages(tenant),
            advantagesCTA(tenant)
        ];
    }, [
        tenant
    ]), advantagesData = ref7[0], advantagesCTAData = ref7[1];
    var handleClickRequestVisitCta = function() {
        return user && !isLoading ? (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "FloatingBanner_RequestVisit") : (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "RequestVisit");
    };
    (0,react.useEffect)(function() {
        if (buyerInfo) {
            (0,eventsHandlers/* handleShow */.Hf)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "Access-FromMail");
        }
    }, [
        buyerInfo
    ]);
    var handleHideToastError = function() {
        setShowToastError(false);
        setSubmitting(false);
    };
    var handleBannerCtaClick = function() {
        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "InfoBanner_TellMeMore");
        var headerOffset = device === "desktop" && common_variables/* headerHeightDesktop */.QV + parseInt(theme/* theme.spacings.2xl */.r.spacings["2xl"]);
        window.scrollTo({
            behavior: "smooth",
            top: casavoInventoryBannerBigRef.current.offsetTop - headerOffset
        });
    };
    var handleRequestVisitCtaBuyerInfo = function() {
        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "FloatingBanner_RequestVisit");
        switch(buyerInfo.tenant_id){
            case constants/* TENANTS.ucsc */.rk.ucsc:
                setSubmitting(true);
                return expressVisit({
                    args: {
                        contactId: buyerInfo.contact_id
                    },
                    tenant: buyerInfo.tenant_id
                }).then(function() {
                    setShowToastError(false);
                    setVisitInterest(api_gluglu_auth/* GetPotentialPropertyVisitInterestResponse.INTEREST_ALREADY_EXPRESSED */.Mc.INTEREST_ALREADY_EXPRESSED);
                }).catch(function(error) {
                    setShowToastError(true);
                    esm_exports/* captureException */.Tb(error, function(scope) {
                        scope.setExtra("channel", "lisa.priorityProperty");
                        return scope;
                    });
                }).finally(function() {
                    setSubmitting(false);
                });
            case constants/* TENANTS.casavo */.rk.casavo:
                return openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(VisitRequestModal, {
                    buyerInfo: buyerInfo,
                    expressVisitInterest: function(args) {
                        return expressVisit({
                            args: args,
                            tenant: buyerInfo.tenant_id
                        });
                    },
                    setShowToastError: setShowToastError,
                    thankYouPageUrl: thankYouPageUrl
                }), {
                    overlay: true
                });
        }
    };
    var handleLockedPriorityLogin = function() {
        resetVisitInterestBeforeLogin();
        if (device === "mobile") {
            openBottomSheet(/*#__PURE__*/ (0,jsx_runtime.jsx)(UserAuthentication/* UserAuthentication */.z, {
                conceptImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                    height: 75,
                    name: "ideas",
                    width: 75
                }),
                mainTitle: "Login_PriorityDetail_BottomSheet_UnlockTitle",
                returnUrl: window.location.href,
                touchPoint: "FromLockedPriority",
                onLoggedIn: closeBottomSheet
            }), {
                bgColor: "offWhite",
                isPriority: true,
                minHeight: 610
            });
        } else {
            openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModalForm/* default */.Z, {
                isPriority: true,
                bgColor: "offWhite",
                conceptImage: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConceptImage/* ConceptImage */.t, {
                    height: 120,
                    name: "ideas",
                    width: 120
                }),
                mainTitle: "Login_PriorityDetail_BottomSheet_UnlockTitle",
                returnURL: window.location.href,
                touchPoint: "FromLockedPriority",
                onLoggedIn: closeModal
            }), LoginModalForm/* loginModalFormOptions */.S);
        }
    };
    (0,react.useEffect)(function() {
        var fetchVisitInterest = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var result, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,api_gluglu_auth/* initApi */.g8)().getPotentialPropertyVisitInterest(priority.transactionId)
                            ];
                        case 1:
                            result = _state.sent();
                            setVisitInterest(result);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.error("Error:", error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchVisitInterest() {
                return _ref.apply(this, arguments);
            };
        }();
        if (tenant === constants/* TENANTS.casavo */.rk.casavo) {
            fetchVisitInterest();
        }
        if (!user && !isLoading) {
            (0,eventsHandlers/* handleShow */.Hf)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "View");
        }
    }, [
        user,
        isLoading,
        tenant
    ]);
    (0,react.useEffect)(function() {
        if ((0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && typeof window.sessionStorage !== "undefined") {
            (0,new_property/* storePropertyVisited */.yG)(priority.transactionId);
        }
    }, []);
    var handleUnlock = function() {
        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "Unlock", "FromPhotoCarousel");
        handleLockedPriorityLogin();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,sprinkles_css/* sprinkles */.K)({
            paddingBottom: {
                desktop: 0,
                mobile: "4xl"
            }
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
            contentWidth: "default",
            showHeaderOnMobile: false,
            tenant: tenant,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(priorityDetailGalleryWrapper, index_css/* layoutContentInnerStretched */.F$, (0,sprinkles_css/* sprinkles */.K)({
                            paddingBottom: isPriorityLocked ? "4xl" : "xl",
                            paddingTop: "xl"
                        })),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()(index_css/* contentLayoutInner.default */.yx["default"], isPriorityLocked && (0,sprinkles_css/* sprinkles */.K)({
                                position: "relative"
                            })),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: priorityDetailGalleryHeader,
                                    children: isPriorityLocked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
                                            display: "flex"
                                        }), styles_css/* gap.l */.SG.l),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                                noMargin: true,
                                                size: "m",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                                    i18Key: "priority:PriorityDeatil_NotLogged_Intro_Description"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* TextLinkButton */.Rw, {
                                                label: t("priority:PriorityDetail_NotLogged_Intro_CTA"),
                                                onClick: function() {
                                                    (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "Unlock", "FromTopDescription");
                                                    handleLockedPriorityLogin();
                                                }
                                            })
                                        ]
                                    }) : tenant === constants/* TENANTS.casavo */.rk.casavo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            display: "flex",
                                            gap: "s"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "aria-label": "",
                                                role: "img",
                                                children: "\uD83C\uDFE1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                                noMargin: true,
                                                size: "m",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                                                    i18Key: "priority:Priority_DetailPage_PreviewDescription"
                                                })
                                            })
                                        ]
                                    }) : null
                                }),
                                device === "mobile" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileImageGallery/* MobileImageGallery */.f, {
                                    cities: cities,
                                    citySlug: priority.city,
                                    eventCategory: eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail,
                                    handleUnlock: isPriorityLocked && handleUnlock,
                                    photos: photoGallery,
                                    planimetryUrl: planimetry,
                                    title: priority.title
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImageGallery/* DesktopImageGallery */.S, {
                                    cities: cities,
                                    citySlug: priority.city,
                                    eventCategory: eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail,
                                    handleUnlock: isPriorityLocked && handleUnlock,
                                    id: priority.transactionId,
                                    photos: photoGallery,
                                    planimetryUrl: planimetry,
                                    title: priority.title
                                }),
                                !isPriorityLocked && planimetry && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailGalleryButton/* DetailGalleryButton */.F, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        marginLeft: {
                                            desktop: 0,
                                            mobile: "m"
                                        },
                                        marginTop: "m"
                                    }),
                                    Icon: function() {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            kind: "floorplan"
                                        });
                                    },
                                    label: t("listing-detail:planimetry"),
                                    onClick: function(event) {
                                        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.PriorityDetail */.z.PriorityDetail, "Planimetry");
                                        event.preventDefault();
                                        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryAndPlanimetry.ModalGalleryAndPlanimetry, {
                                            cities: cities,
                                            citySlug: priority.city,
                                            closeModal: closeModal,
                                            images: photoGallery,
                                            openType: "planimetry",
                                            planimetryUrl: planimetry,
                                            startIndex: 0,
                                            title: priority.title
                                        }));
                                    }
                                }),
                                isPriorityLocked && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: priorityDetailPhotoCta,
                                    onClick: function() {
                                        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "Unlock", "FromPhotoCTA");
                                        handleLockedPriorityLogin();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon/* default.Lock */.Z.Lock, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                            noMargin: true,
                                            size: "s",
                                            children: t("priority:PriorityDetail_NotLogged_Intro_CTA")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Icon/* default.Chevron */.Z.Chevron, {})
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityDetailInfo, {
                        advantages: advantagesCTAData,
                        disableVisitCTA: isSubmitting,
                        handleBannerCtaClick: handleBannerCtaClick,
                        handleRequestVisitCtaBuyerInfo: handleRequestVisitCtaBuyerInfo,
                        hasBuyerInfo: Boolean(buyerInfo),
                        isPriorityLocked: isPriorityLocked,
                        priority: priority,
                        setShowToastError: setShowToastError,
                        showAlreadyBookedBanner: showAlreadyBookedBanner,
                        thankYouPageUrl: (0,i18n_routes/* getPriorityThankyouPage */.sA)(priority.slug, priority.city)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: casavoInventoryBannerBigRef,
                        className: index_css/* layoutContentInnerStretched */.F$,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InventoryBannerBig/* InventoryBannerBig */.c, {
                                advantages: advantagesData,
                                color: "brandedBackground",
                                hasContentBottom: isPriorityLocked,
                                inventory: listing/* CasavoInventory.Priority */.M.Priority,
                                tenant: tenant
                            }),
                            isPriorityLocked && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((0,sprinkles_css/* sprinkles */.K)({
                                    paddingBottom: "l",
                                    paddingTop: "s"
                                }), styles_css/* backgroundColor.brandedBackground */.Cz.brandedBackground),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    center: true,
                                    label: t("priority:Priority_DetailPage_AdvantagesBox_CTA"),
                                    styleVariant: "secondary",
                                    onClick: function() {
                                        (0,eventsHandlers/* handleClick */.qk)(eventCategory/* GTMEventCategory.LockedPriorityDetail */.z.LockedPriorityDetail, "Unlock", "FromInfoBanner");
                                        handleLockedPriorityLogin();
                                    }
                                })
                            })
                        ]
                    }),
                    similarProperties.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SimilarPropertiesSection, {
                        similarListings: similarListings,
                        similarPriorities: similarPriorities
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: floatingCta,
                        children: showAlreadyBookedBanner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()(styles_css/* backgroundColor.greyscale50 */.Cz.greyscale50, (0,sprinkles_css/* sprinkles */.K)({
                                        marginBottom: "m",
                                        padding: "m"
                                    })),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,sprinkles_css/* sprinkles */.K)({
                                            paddingX: "4xl",
                                            textAlign: "center"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Body */.uT, {
                                            noMargin: true,
                                            color: "root.neutral.400",
                                            size: "xs",
                                            children: t("priority:PriorityDetail_FloatingBanner_Booked_Description")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AlreadyBookedBanner, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        marginBottom: "m",
                                        marginX: "m"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,sprinkles_css/* sprinkles */.K)({
                                display: "flex",
                                gap: "s",
                                padding: "m"
                            }),
                            children: [
                                tenant === constants/* TENANTS.casavo */.rk.casavo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFeedback, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        flex: 1
                                    })
                                }),
                                buyerInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    fullWidth: true,
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        flex: 1
                                    }),
                                    disabled: isSubmitting,
                                    label: requestVisitCtaLabel,
                                    loading: user && isSubmitting,
                                    minWidth: 190,
                                    onClick: handleRequestVisitCtaBuyerInfo
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestVisitCTA, {
                                    className: (0,sprinkles_css/* sprinkles */.K)({
                                        flex: 1
                                    }),
                                    gtmTouchPoint: "FromVisitLockedPriority",
                                    handleCtaClick: handleClickRequestVisitCta,
                                    setShowToastError: setShowToastError,
                                    thankYouPageUrl: thankYouPageUrl,
                                    transactionId: priority.transactionId
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                        error: showToastError,
                        setError: handleHideToastError
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/containers/PriorityDetail/index.ts


// EXTERNAL MODULE: ./src/lib/tenants/getTenant.ts
var getTenant = __webpack_require__(12527);
;// CONCATENATED MODULE: ./src/pages/priority/[slug]/index.tsx
// @ts-ignore








var PriorityDetailPage = function(param) {
    var areas = param.areas, buyerInfo = param.buyerInfo, cities = param.cities, priority = param.priority, similarListings = param.similarListings, similarPriorities = param.similarPriorities, tenant = param.tenant;
    var t = (0,useTranslation/* default */.Z)().t;
    (0,react.useEffect)(function() {
        var tenant = (0,getTenant/* getTenant */.dy)();
        if (buyerInfo && buyerInfo.tenant_id && buyerInfo.tenant_id !== tenant) {
            throw new Error("Buyer info tenant mismatch for host ".concat(window.location.host, " and buyer info tenant ").concat(buyerInfo.tenant_id));
        }
        if (buyerInfo && buyerInfo.tenant_id && buyerInfo.tenant_id !== tenant) {
            throw new Error("Buyer info tenant mismatch for host ".concat(window.location.host, " and buyer info tenant ").concat(buyerInfo.tenant_id));
        }
    }, [
        buyerInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            t("priority:PriorityDetailPage_Title"),
                            " - ",
                            priority.title
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "noindex, nofollow",
                        name: "robots"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TenantContextProvider, {
                tenant: tenant,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cities/* CitiesProvider */.Ft, {
                    areas: areas,
                    cities: cities,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriorityDetail, {
                        buyerInfo: buyerInfo,
                        cities: {
                            areas: areas,
                            list: cities
                        },
                        priority: priority,
                        similarListings: similarListings,
                        similarPriorities: similarPriorities
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (PriorityDetailPage);
 // @ts-ignore


/***/ }),

/***/ 21702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ deferredRequest; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63796);

var deferredRequest = function(request, millisec) {
    var p = new Promise(function(resolve) {
        setTimeout(function() {
            resolve(millisec);
        }, millisec);
    });
    return Promise.all([
        request,
        p
    ]).then(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 1), res = _param[0];
        return res;
    });
};


/***/ }),

/***/ 53049:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 91238:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 70667:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 72435:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2653:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5949,8009,7385,8396,3406,9421,6347,4505,8928,1572,4106,7769,2715,2153,5829,7275,5522,2675,9848,6451,9008,5630,9774,2888,179], function() { return __webpack_exec__(18510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);